"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[110],{

/***/ 57066:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LandingPage": () => (/* binding */ LandingPage),
/* harmony export */   "__N_SSP": () => (/* binding */ __N_SSP),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _insurance_landing_ui_pages__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7928);
/* harmony import */ var _tm_insurance_analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2182);
/* harmony import */ var _tm_insurance_navigation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91908);
/* harmony import */ var _tm_insurance_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64264);
/* harmony import */ var _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(44928);
/* harmony import */ var _tm_ui_widgets__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87109);
/* harmony import */ var _tm_ui_widgets_context__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12283);
/* harmony import */ var _tm_ui_widgets_hoc__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63837);
/* harmony import */ var _tm_ui_hoc__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(99234);
/* harmony import */ var pwa_mmt_ui_header_ssr_header_css__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4766);
/* harmony import */ var pwa_mmt_ui_header_ssr_header_css__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(pwa_mmt_ui_header_ssr_header_css__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _src_hoc__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8367);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(52322);













const analytics = (0,_tm_insurance_analytics__WEBPACK_IMPORTED_MODULE_2__/* .getAnalytics */ .I)();
var __N_SSP = true;
function LandingPage({
  data,
  device = "mobile",
  error,
  partner,
  referrer,
  commonsHeaderData
}) {
  const headTags = data?.headTags || {};
  const {
    0: activeModal,
    1: setActiveModal
  } = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("");
  (0,_tm_insurance_analytics__WEBPACK_IMPORTED_MODULE_2__/* .setLandingPageAnalytics */ .Q)(data?.analytics?.pageLoad);
  const longImageUrl = data?.offers?.items?.[0]?.image_url;

  const goToMyOrders = () => {
    analytics?.trackLandingEvents({
      actionType: "my_orders_clicked"
    } //'click'
    );
    const authCookie = (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_4__/* .getCookieByName */ .A7)("mmt-auth") || (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_4__/* .getCookieByName */ .A7)("OAUTH-GOIBIBO");

    if (authCookie) {
      _tm_insurance_navigation__WEBPACK_IMPORTED_MODULE_3__/* .navigationActionsSeo.navigateToOrderListing */ .Ro.navigateToOrderListing();
    } else {
      setActiveModal?.("LOGIN");
    }
  }; // TODO: move header configurations to context


  const component = partner === _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_5__.PARTNER.GI ? (0,_tm_ui_hoc__WEBPACK_IMPORTED_MODULE_9__.withGIInsuranceHeader)( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_tm_ui_widgets_context__WEBPACK_IMPORTED_MODULE_7__/* .PartnerContextProvider */ .L, {
    partnerType: _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_5__.PARTNER.GI,
    "data-test-id": "component-PartnerContextProvider",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_insurance_landing_ui_pages__WEBPACK_IMPORTED_MODULE_1__/* .InsuranceLanding */ .pB, {
      setActiveModal: setActiveModal,
      data: data,
      "data-test-id": "component-InsuranceLanding"
    })
  }), {
    Wrapper: _insurance_landing_ui_pages__WEBPACK_IMPORTED_MODULE_1__/* .InsuranceGiLandingPageMainWrapper */ .Bk,
    forceLogin: activeModal ? true : false
  }, "Secure International Travel", true, goToMyOrders, false, false) : (0,_tm_ui_hoc__WEBPACK_IMPORTED_MODULE_9__.withMMTInsuranceHeader)( /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_tm_ui_widgets_context__WEBPACK_IMPORTED_MODULE_7__/* .PartnerContextProvider */ .L, {
    partnerType: _tm_isomorphic_utils__WEBPACK_IMPORTED_MODULE_5__.PARTNER.MMT,
    "data-test-id": "component-PartnerContextProvider",
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__.jsx)(_insurance_landing_ui_pages__WEBPACK_IMPORTED_MODULE_1__/* .InsuranceLanding */ .pB, {
      setActiveModal: setActiveModal,
      data: data,
      "data-test-id": "component-InsuranceLanding"
    })
  }), {
    type: "dualHeader",
    Wrapper: _insurance_landing_ui_pages__WEBPACK_IMPORTED_MODULE_1__/* .InsuranceLandingPageMainWrapper */ .x1,
    activeModal: activeModal ? "LOGIN" : undefined,
    onModalChange: modal => setActiveModal(modal),
    globalConfig: commonsHeaderData?.headerConfig?.value,
    headerCommonData: {
      loyaltyHeaderData: commonsHeaderData?.loyaltyHeaderData?.value,
      walletHeaderData: commonsHeaderData?.walletHeaderData?.value,
      mobileCore: commonsHeaderData?.mobileCore?.value,
      userInfoData: commonsHeaderData?.userInfoData?.value
    }
  }, "Secure International Travel", true, goToMyOrders, false, false, false, false);
  return (0,_tm_ui_hoc__WEBPACK_IMPORTED_MODULE_9__.withError)((0,_tm_ui_widgets_hoc__WEBPACK_IMPORTED_MODULE_8__/* .withReferrerProvider */ .ut)((0,_tm_ui_widgets__WEBPACK_IMPORTED_MODULE_6__/* .withDeviceAndThemeProvider */ .OM)((0,_src_hoc__WEBPACK_IMPORTED_MODULE_11__/* .withSeoHeadTags */ ._)(component, headTags, partner, longImageUrl), device, {
    pageTheme: partner
  }), referrer), error, "LANDING");
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (LandingPage);

/***/ }),

/***/ 8367:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "_": () => (/* reexport */ withSeoHeadTags)
});

// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ./src/hoc/withSeoHeadTags.tsx




function withSeoHeadTags(component, headTags, partner, longImageUrl) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      "data-test-id": "Head",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        "data-test-id": "title",
        children: headTags?.title || "Travel Insurance - MakeMyTrip"
      }), headTags?.metaTags?.map((metaTag, index) => {
        if (metaTag.name && metaTag.content) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
            name: metaTag.name,
            content: metaTag.content,
            "data-test-id": `meta-${index}`
          }, index);
        }
      }), headTags?.title && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: headTags?.title,
        "data-test-id": "meta"
      }), headTags?.metaTags?.find(meta => meta.name === "description")?.content && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: headTags?.metaTags?.find(meta => meta.name === "description")?.content,
        "data-test-id": "meta"
      }), longImageUrl && /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
          property: "og:image",
          content: longImageUrl,
          "data-test-id": "meta"
        })
      }), headTags?.title && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "twitter:title",
        content: headTags?.title,
        "data-test-id": "meta"
      }), headTags?.metaTags?.find(meta => meta.name === "description")?.content && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "twitter:description",
        content: headTags?.metaTags?.find(meta => meta.name === "description")?.content,
        "data-test-id": "meta"
      }), longImageUrl && /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "twitter:image",
        content: longImageUrl,
        "data-test-id": "meta"
      }), headTags?.schema?.map((schema, index) => {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("script", {
          type: "application/ld+json",
          dangerouslySetInnerHTML: {
            __html: JSON.stringify(schema)
          },
          "data-test-id": "script"
        }, `schema-${index}`);
      }), headTags?.canonical ? /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: headTags.canonical,
        "data-test-id": "link"
      }) : null]
    }), component]
  });
}
;// CONCATENATED MODULE: ./src/hoc/index.ts


/***/ }),

/***/ 21810:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": () => (/* binding */ conditionallyLoadWebVitals)
/* harmony export */ });
/* harmony import */ var _webVitalsImpl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69056);
// Re-export for backward compatibility

/**
 * Conditionally loads web vitals script as a chunk for 10% of users
 * Uses sessionStorage to track if already loaded to avoid reloading
 * Only downloads the chunk if user falls into the 10% sample
 */

const conditionallyLoadWebVitals = async () => {
  // Check if running on client side
  if ( false || typeof sessionStorage === "undefined") {
    return;
  }

  const SAMPLE_PERCENTAGE = 0.2; // 10%
  // Randomly decide if user falls into 10% sample (client-side decision)

  const isInSample = Math.random() <= SAMPLE_PERCENTAGE;

  if (!isInSample) {
    console.log("User not in sample, not loading web vitals");
    return;
  }

  try {
    // Dynamically import the web vitals implementation as a chunk
    const {
      addWebVitalsScript
    } = await Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 69056)); // Call the function

    addWebVitalsScript(); // Mark as loaded in sessionStorage to prevent reloading
  } catch (error) {
    console.error("Failed to load web vitals chunk:", error);
  }
};

/***/ }),

/***/ 69056:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "addWebVitalsScript": () => (/* binding */ addWebVitalsScript)
/* harmony export */ });
/* harmony import */ var _mmt_web_vitals_logger__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(60807);

/**
 * Web Vitals implementation - loaded as a separate chunk
 */

const addWebVitalsScript = (sampleSpace = 100) => {
  const Event = new _mmt_web_vitals_logger__WEBPACK_IMPORTED_MODULE_0__/* .CaptureWebVitals */ .Z("web_vitals_values", sampleSpace, 193673, "mmt_insurance_b2c_pdt_client_metric_logging", undefined, true);
  Event?.init(true, true, true, "");
};

/***/ }),

/***/ 91381:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "DownloadPolicy": () => (/* reexport */ OrderDetail_DownloadPolicy),
  "GiFooterWrap": () => (/* reexport */ GiFooterWrap),
  "InsuranceAddPassport": () => (/* reexport */ InsuranceAddPassport_InsuranceAddPassport),
  "InsuranceCommonLanding": () => (/* reexport */ InsuranceCommonLanding_InsuranceCommonLanding),
  "InsuranceCommonLandingPageMainWrapper": () => (/* reexport */ InsuranceCommonLandingPageMainWrapper),
  "InsuranceGiCommonLandingPageMainWrapper": () => (/* reexport */ InsuranceGiCommonLandingPageMainWrapper),
  "InsuranceGiLandingPageMainWrapper": () => (/* reexport */ InsuranceLanding_style/* InsuranceGiLandingPageMainWrapper */.Bk),
  "InsuranceLanding": () => (/* reexport */ InsuranceLanding_InsuranceLanding),
  "InsuranceLandingMyBizPageMainWrapper": () => (/* reexport */ InsuranceLanding_style/* InsuranceLandingMyBizPageMainWrapper */.lg),
  "InsuranceLandingMyPartnerPageMainWrapper": () => (/* reexport */ InsuranceLanding_style/* InsuranceLandingMyPartnerPageMainWrapper */.wB),
  "InsuranceLandingPageMainWrapper": () => (/* reexport */ InsuranceLanding_style/* InsuranceLandingPageMainWrapper */.x1),
  "InsuranceLandingShimmer": () => (/* reexport */ InsuranceLanding_InsuranceLandingShimmer),
  "InsuranceListingWrapper": () => (/* reexport */ InsuranceListing_InsuranceListingWrapper),
  "InsurancePaySuccess": () => (/* reexport */ InsurancePaySuccess_InsurancePaySuccess),
  "InsuranceTravellerDetailShimmer": () => (/* reexport */ InsuranceTravellerDetail_InsuranceTravellerDetailShimmer),
  "InsuranceTravellerDetailWrapper": () => (/* reexport */ InsuranceTravellerDetail_InsuranceTravellerDetailWrapper),
  "OrderDetail": () => (/* reexport */ OrderDetail_OrderDetail),
  "OrderListingPage": () => (/* reexport */ OrderListingPage_OrderListingPage),
  "ThankYouPage": () => (/* reexport */ ThankYouPage_ThankYouPage),
  "TravelDetailsV2ContextProvider": () => (/* reexport */ TravelDetailsV2ContextProvider),
  "useTravelDetailsV2Context": () => (/* reexport */ useTravelDetailsV2Context)
});

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/OmnitureAnalytics/insurance/index.ts + 7 modules
var insurance = __webpack_require__(2182);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/index.ts
var XDMAnalytics = __webpack_require__(50354);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/api/index.ts + 2 modules
var api = __webpack_require__(78521);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/navigation/index.ts + 3 modules
var navigation = __webpack_require__(91908);
// EXTERNAL MODULE: ../../libs/utility/src/lib/insurance/utils/index.ts + 4 modules
var utils = __webpack_require__(64264);
// EXTERNAL MODULE: ../../libs/isomorphic-utils/src/index.ts + 7 modules
var src = __webpack_require__(44928);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/index.tsx + 10 modules
var static_components = __webpack_require__(98790);
// EXTERNAL MODULE: ../../libs/ui/src/index.ts
var ui_src = __webpack_require__(76609);
// EXTERNAL MODULE: ../../libs/ui-widgets/src/index.ts + 2 modules
var ui_widgets_src = __webpack_require__(87109);
// EXTERNAL MODULE: ../../libs/utility/src/index.ts + 1 modules
var utility_src = __webpack_require__(97427);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/InsuranceAddPassport/InsuranceAddPassport.tsx













const analytics = (0,insurance/* getAnalytics */.I)();

const InsuranceAddPassport = ({
  passportDetailsData
}) => {
  const {
    0: pageId,
    1: setPageId
  } = (0,react.useState)(src.PASSPORT_DETAILS_PAGE_ID.PAYMENT_SUCCESS);
  const {
    0: bookingId,
    1: setBookingId
  } = (0,react.useState)("");
  const {
    0: showModal,
    1: setShowModal
  } = (0,react.useState)(false);
  const {
    0: showBenefitsModal,
    1: setShowBenefitsModal
  } = (0,react.useState)(false);
  const {
    0: isLoading,
    1: setIsLoading
  } = (0,react.useState)(false);
  const {
    0: passportError,
    1: setPassportError
  } = (0,react.useState)();
  const {
    type
  } = (0,ui_src/* usePlanType */.U)();
  const {
    heading,
    subHeading,
    planCardTitle,
    SelectedPlanData,
    travellerData,
    addPassportTitle,
    addPassportInfo,
    passport,
    submitCtaText,
    skipCtaText,
    addPassportModalData,
    planBenefits
  } = passportDetailsData;
  const {
    viewBenefitsCta,
    totalBenefits,
    featureGroup,
    claimSettled,
    tnc,
    planBenefitsInfo
  } = planBenefits || {};
  const planBenefitsData = {
    productId: "",
    quoteId: "",
    packName: SelectedPlanData?.planType,
    insuranceType: SelectedPlanData?.planName,
    insPlanName: SelectedPlanData?.vendorName,
    vendorDisplayPrefix: SelectedPlanData?.vendorNamePrefix,
    planExtraInfo: claimSettled,
    service: planBenefitsInfo,
    ctaLink: tnc?.title,
    tncLink: tnc?.link,
    moreBenefits: featureGroup
  };
  const experiment = (0,react.useContext)(ui_widgets_src/* ExperimentTrackingString */.Mq) || "";
  (0,react.useEffect)(() => {
    analytics?.trackPageLoadEvent({
      pageName: "ADD_PASSPORT",
      bookingId: bookingId || "",
      experiment
    });
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "ADD_PASSPORT"
      }
    });
  }, []);
  (0,react.useEffect)(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const pageid = queryParams.get("pageId");
    setPageId(pageid);
    const bookingid = queryParams.get("bookingId");
    setBookingId(bookingid);
  }, [pageId]);

  const handleAddPassportModal = () => {
    setShowModal(!showModal);
  };

  const navigateToNextPage = () => {
    if (pageId === src.PASSPORT_DETAILS_PAGE_ID.PAYMENT_SUCCESS) {
      navigation/* navigationActions.navigateToOrderConfirmed */.ej.navigateToOrderConfirmed({
        bookingId,
        type: type || ""
      });
    } else {
      navigation/* navigationActions.navigateToOrderDetails */.ej.navigateToOrderDetails({
        bookingId
      });
    }
  };

  const handleSubmitClick = async reqData => {
    try {
      const partner = (0,utils/* getPartnerOnClientSide */.et)();
      setIsLoading(true);
      const response = await (0,api/* editInsuranceDetails */.oe)({
        partner,
        bookingID: bookingId,
        data: reqData
      });
      setIsLoading(false);
      const {
        responseStatus
      } = response;

      if (responseStatus === src.RESPONSE_STATUS.SUCCESS) {
        navigateToNextPage();
      } else {
        setPassportError("Something went wrong!");
      }
    } catch (err) {
      setIsLoading(false);
      const {
        error
      } = err?.response?.data || {};
      setPassportError(error);
    }
  };

  if (passportError && true) {
    throw new utility_src/* ClientError */.XF(passportError);
  }

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(static_components.DesktopLayout, {
      title: heading,
      subTitle: subHeading,
      leftComp: /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.InsuranceBooked, {
          title: planCardTitle,
          selectedPlanData: SelectedPlanData,
          viewBenefitsCta: viewBenefitsCta,
          handleViewBenefits: () => setShowBenefitsModal(true),
          "data-test-id": "InsuranceAddPassport-InsuranceBooked"
        })
      }),
      rightComp: /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.PassportNumComp, {
          isLoading: isLoading,
          title: addPassportTitle,
          info: addPassportInfo,
          submitCtaText: submitCtaText,
          skipCtaText: skipCtaText,
          travellerData: travellerData,
          passportFormData: passport,
          handleAddPassportModal: handleAddPassportModal,
          handleSubmitClick: handleSubmitClick,
          "data-test-id": "InsuranceAddPassport-PassportNumComp"
        })
      }),
      "data-test-id": "InsuranceAddPassport-DesktopLayout"
    }), showBenefitsModal && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.MoreBenefits, {
      handleClose: () => setShowBenefitsModal(false),
      moreBenfitsTitle: totalBenefits,
      data: planBenefitsData,
      "data-test-id": "InsuranceAddPassport-MoreBenefits"
    }), showModal && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.AddPassportModal, {
      data: addPassportModalData,
      handleSkip: navigateToNextPage,
      handleClose: handleAddPassportModal,
      "data-test-id": "InsuranceAddPassport-AddPassportModal"
    })]
  });
};

/* harmony default export */ const InsuranceAddPassport_InsuranceAddPassport = (InsuranceAddPassport);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/@growth/dweb-footer/dist/growth-dweb-footer.esm.js
var growth_dweb_footer_esm = __webpack_require__(26147);
// EXTERNAL MODULE: ../../libs/utility/src/lib/css/Global.ts
var Global = __webpack_require__(42874);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/CommonLandingDT/CommonLandingDT.tsx
var CommonLandingDT = __webpack_require__(56397);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/QnABlock/QnABlock.tsx + 1 modules
var QnABlock = __webpack_require__(46299);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/pages/InsuranceLanding/InsuranceLanding.style.ts
var InsuranceLanding_style = __webpack_require__(63646);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/InsuranceCommonLanding/InsuranceCommonLanding.style.ts



const CommonLandingPwaWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceCommonLandingstyle__CommonLandingPwaWrapper",
  componentId: "sc-18to2mw-0"
})(["min-height:100vh;width:100vw;background-color:", ";padding:16px;"], Global/* theme.whiteText2 */.rS.whiteText2);
const GiFooterWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceCommonLandingstyle__GiFooterWrap",
  componentId: "sc-18to2mw-1"
})(["width:100%;"]);
const InsuranceGiCommonLandingPageMainWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceCommonLandingstyle__InsuranceGiCommonLandingPageMainWrapper",
  componentId: "sc-18to2mw-2"
})([":before{content:\"\";position:absolute;top:0;width:100%;left:0;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1440' height='256' fill='none'%3E%3Cpath fill='url(%23a)' fill-rule='evenodd' d='M1440 167.207C1224.62 223.655 980.573 255.5 722 255.5c-260.175 0-505.644-32.241-722-89.345V0h1440v167.207Z' clip-rule='evenodd'/%3E%3Cdefs%3E%3ClinearGradient id='a' x1='0' x2='1048.73' y1='0' y2='787.836' gradientUnits='userSpaceOnUse'%3E%3Cstop stop-color='%23FF6D38'/%3E%3Cstop offset='1' stop-color='%23DB7A21'/%3E%3C/linearGradient%3E%3C/defs%3E%3C/svg%3E\"),url(\"https://go-assets.ibcdn.com/u/GI/images/1715677875363-bg-dweb.webp\");background-size:100% 382px;background-repeat:no-repeat;height:382px;}"]);
const InsuranceCommonLandingPageMainWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceCommonLandingstyle__InsuranceCommonLandingPageMainWrapper",
  componentId: "sc-18to2mw-3"
})(["background-size:100% 685px;background-repeat:no-repeat;background-color:", ";padding-top:5px;position:relative;z-index:2;@media ", "{background-image:none;padding-top:0px;}"], props => props.isCommonLandingRevamp ? Global/* theme.lightGreyBG */.rS.lightGreyBG : Global/* theme.whiteText */.rS.whiteText, src.deviceType.mobile);
const CommonDesktopLayoutContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceCommonLandingstyle__CommonDesktopLayoutContainer",
  componentId: "sc-18to2mw-4"
})(["display:flex;flex-direction:column;> *:not(:last-child){margin-bottom:", ";}> *:nth-last-child(2){margin-bottom:0;}"], props => props.customMarginBottom ? `${props.customMarginBottom}px` : "60px");
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/InsuranceCommonLanding/InsuranceCommonLanding.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }














 // import TravelProtection from "../../components/TravelProtection/TravelProtection";


 // Code-split components with SSR enabled (for desktop)



const ClaimYourInsurance = dynamic_default()(() => Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98790)).then(mod => mod.ClaimYourInsurance), {
  ssr: true,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(98790)]
  }
});
const BottomBar = dynamic_default()(() => Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 16724)), {
  ssr: true,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(16724)]
  }
});
const LandingFooter = dynamic_default()(() => Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98790)).then(mod => mod.LandingFooter), {
  ssr: true,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(98790)]
  }
});
const WhyBuyTravIns = dynamic_default()(() => Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98790)).then(mod => mod.WhyBuyTravIns), {
  ssr: true,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(98790)]
  }
});
const TravelProtection = dynamic_default()(() => __webpack_require__.e(/* import() */ 5365).then(__webpack_require__.bind(__webpack_require__, 85365)), {
  ssr: true,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(85365)]
  }
});
const LandingTestimonials = dynamic_default()(() => Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 98790)).then(mod => mod.LandingTestimonials), {
  ssr: true,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(98790)]
  }
});
const SeoContent = dynamic_default()(() => Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 51066)).then(mod => mod.SeoContent), {
  ssr: true,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(51066)]
  }
}); // Lazy-loaded PWA/mobile components (client-side only)

const HeroSection = dynamic_default()(() => __webpack_require__.e(/* import() */ 8314).then(__webpack_require__.bind(__webpack_require__, 8314)), {
  ssr: false,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(8314)]
  }
});
const HeaderCard = dynamic_default()(() => __webpack_require__.e(/* import() */ 376).then(__webpack_require__.bind(__webpack_require__, 30376)), {
  ssr: false,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(30376)]
  }
});
const TravelPlans = dynamic_default()(() => __webpack_require__.e(/* import() */ 5984).then(__webpack_require__.bind(__webpack_require__, 35984)), {
  ssr: false,
  loadableGenerated: {
    webpack: () => [/*require.resolve*/(35984)]
  }
});
const giFooterData = [{
  title: "Popular Flight Sectors",
  links: [{
    text: "Kolkata to Delhi Flight",
    url: "https://www.goibibo.com/flights/kolkata-to-delhi-flights/"
  }, {
    text: "Hyderabad to Delhi Flight",
    url: "https://www.goibibo.com/flights/hyderabad-to-delhi-flights/"
  }]
}];
const InsuranceCommonLanding_analytics = (0,insurance/* getAnalytics */.I)();

const InsuranceCommonLanding = ({
  data,
  partnerType,
  setActiveModal,
  query
}) => {
  const experiment = (0,react.useContext)(ui_widgets_src/* ExperimentTrackingString */.Mq) || "";
  const {
    setType,
    type
  } = (0,ui_src/* usePlanType */.U)();
  const {
    travelProtection,
    desktopLayout,
    travelInsurance,
    heading,
    offers,
    footer: footerInfoData,
    pokusExperiments,
    bottomBarInfo,
    qnABlockInfo,
    seoContent,
    claimYourInsurance,
    testimonials,
    contentBlockInfo,
    countryCode,
    seoPageType,
    segmentId,
    qnaBlockTitle,
    faq: faqData,
    discoveryBarText
  } = data;
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const footerInfo = footerInfoData || []; // || LOCAL_FOOTER_INFO;
  //TODO: move this Logic to the LandingFooter component and remove below duplicate code from wherever it's getting used

  const footerLinks = footerInfo?.filter(data => data.type === "section")?.map((item, index) => ({
    id: index.toString(),
    label: item.title || "",
    listPoints: item?.links?.map((link, i) => ({
      id: i.toString(),
      label: link.title || "",
      link: link.url || ""
    })) ?? [],
    icon: ""
  })) ?? [];
  const footerHeading = footerInfo?.find(data => data.type === "rich-text");
  const footnoteData = footerInfo?.find(data => data.type === "footnote");
  const footerCopyrightData = footnoteData && "items" in footnoteData ? {
    type: footnoteData.type,
    items: footnoteData.items?.length ? [footnoteData.items[0]] : undefined
  } : undefined;
  (0,react.useEffect)(() => {
    if (desktopLayout?.travelFormInfo?.travellerInfoSection) {
      (0,utils/* replaceHistory */.df)("isRetail", "true");
      InsuranceCommonLanding_analytics?.trackPageLoadEvent({
        pageName: "COMMON_LANDING_RETAIL",
        experiment
      }, type);
    } else {
      InsuranceCommonLanding_analytics?.trackPageLoadEvent({
        pageName: "COMMON_LANDING",
        experiment
      }, type);
    }

    const queryParams = new URLSearchParams(window.location.search);
    const {
      value = []
    } = desktopLayout?.travelFormInfo?.countryList || {};
    const selectedCountriesForQuery = query?.countries || queryParams.get("countries");
    const selectedCountryCodes = selectedCountriesForQuery?.split(",");
    const subpageName = queryParams.get("type") || query?.type;
    let totalCountryData = value?.map(data => {
      if (selectedCountryCodes?.includes(data.code)) {
        return _objectSpread(_objectSpread({}, data), {}, {
          isSelected: true
        });
      }

      return _objectSpread({}, data);
    });
    const selectedCountry = totalCountryData?.filter(item => item.isSelected);

    if (value?.length) {
      localStorage.setItem("TRAVEL_INSURANCE_COUNTRIES", JSON.stringify(value));
    }

    (0,XDMAnalytics.initializePageTracking)({
      page_context: {
        page_name: "landing",
        funnel_step: "landing",
        page_type: "landing",
        subpage_name: "common_landing"
      },
      event_tracking_context: {
        funnel_entry: "direct"
      }
    }, {
      countries: selectedCountry ? selectedCountry : [],
      journeyType: query?.segment || queryParams.get("segment"),
      travellers: parseInt(query?.travellers || queryParams.get("travellers") || "1"),
      fromDateTime: query?.startDate || queryParams.get("startDate") ? parseInt(query?.startDate || queryParams.get("startDate") || "0") : 0,
      toDateTime: query?.endDate || queryParams.get("endDate") ? parseInt(query?.endDate || queryParams.get("endDate") || "0") : 0
    });
    return () => {
      (0,XDMAnalytics.triggerPageExit)();
    };
  }, []);

  const handleTravelInsuranceClick = () => {
    InsuranceCommonLanding_analytics?.trackCommonLandingEvents({
      actionType: "travel_insurance_card_clicked"
    });
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "travel_insurance_card_clicked"
      }
    });
    setType(undefined);
    navigation/* navigationActions.navigateToLanding */.ej.navigateToLanding({
      type: ""
    }, false);
  };

  const goToMyOrders = () => {
    InsuranceCommonLanding_analytics?.trackCommonLandingEvents({
      actionType: "my_orders_clicked"
    } //"click"
    );
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "my_orders_clicked"
      }
    });
    (0,XDMAnalytics.triggerPageExit)();
    const authCookie = (0,utils/* getCookieByName */.A7)("mmt-auth");

    if (authCookie) {
      navigation/* navigationActions.navigateToOrderListing */.ej.navigateToOrderListing();
    } else {
      setActiveModal?.("LOGIN");
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    id: "pageId",
    "data-test-id": "InsuranceCommonLanding",
    children: device === "lg" ? /*#__PURE__*/(0,jsx_runtime.jsxs)(CommonDesktopLayoutContainer, {
      customMarginBottom: 30,
      "data-test-id": "InsuranceCommonLanding-CommonDesktopLayoutContainer",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(CommonLandingDT/* default */.Z, {
        data: desktopLayout,
        countryCode: countryCode,
        seoPageType: seoPageType,
        segmentId: segmentId,
        query: query,
        pokus: pokusExperiments,
        "data-test-id": "InsuranceCommonLanding-CommonLandingDT"
      }), (desktopLayout?.carouselPersuasion || desktopLayout?.pageInfo?.offeredBy) && /*#__PURE__*/(0,jsx_runtime.jsxs)(static_components.FlexComp, {
        justifyContent: "space-between",
        width: "1200px",
        margin: "-15px auto 0px",
        padding: "0",
        "data-test-id": "InsuranceCommonLanding-FlexComp",
        children: [desktopLayout?.carouselPersuasion ? /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.CarouselPersuasion, {
          carouselPersuasionData: desktopLayout.carouselPersuasion,
          "data-test-id": "InsuranceCommonLanding-CarouselPersuasion"
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          style: {
            width: "328px"
          }
        }), desktopLayout?.pageInfo?.offeredBy && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.OfferedBySection, {
          data: desktopLayout.pageInfo.offeredBy,
          "data-test-id": "InsuranceCommonLanding-OfferedBySection"
        })]
      }), pokusExperiments?.isCommonLandingRevamp ? /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.TravelProtectionV2, {
        title: travelProtection.title,
        plans: travelProtection.plans,
        icon: travelProtection.icon,
        discoveryText: discoveryBarText,
        "data-test-id": "InsuranceCommonLanding-TravelProtectionV2"
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(TravelProtection, {
        title: travelProtection.title,
        plans: travelProtection.plans,
        "data-test-id": "InsuranceCommonLanding-TravelProtection"
      }), claimYourInsurance && /*#__PURE__*/(0,jsx_runtime.jsx)(ClaimYourInsurance, {
        title: claimYourInsurance.title,
        info: claimYourInsurance.info,
        data: claimYourInsurance.claimData,
        "data-test-id": "InsuranceCommonLanding-ClaimYourInsurance"
      }), testimonials && /*#__PURE__*/(0,jsx_runtime.jsx)(LandingTestimonials, {
        customTitle: testimonials?.title,
        test: testimonials?.testimonialData,
        "data-test-id": "InsuranceCommonLanding-LandingTestimonials"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.CommonLandingBottomComp, {
        desktopLayout: desktopLayout,
        offers: offers,
        bottomBarInfo: bottomBarInfo,
        "data-test-id": "InsuranceCommonLanding-CommonLandingBottomComp"
      }), seoContent && /*#__PURE__*/(0,jsx_runtime.jsx)(SeoContent, {
        seoContent: seoContent,
        "data-test-id": "InsuranceCommonLanding-SeoContent"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(LandingFooter, {
        footerData: footerLinks,
        footerHeading: footerHeading,
        footerCopyrightData: footerCopyrightData,
        footerTheme: "light",
        isCommonLandingRevamp: pokusExperiments?.isCommonLandingRevamp,
        "data-test-id": "InsuranceCommonLanding-LandingFooter"
      }), contentBlockInfo && contentBlockInfo?.length > 0 && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.ContentBlock, {
        data: contentBlockInfo,
        "data-test-id": "InsuranceCommonLanding-ContentBlock"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(QnABlock/* default */.Z, {
        data: faqData?.faqList,
        qnaBlockTitle: faqData?.title,
        "data-test-id": "InsuranceCommonLanding-QnABlock"
      }), partnerType !== src.PARTNER.GI && /*#__PURE__*/(0,jsx_runtime.jsx)(BottomBar, {
        data: bottomBarInfo,
        "data-test-id": "InsuranceCommonLanding-BottomBar"
      }), partnerType === src.PARTNER.GI && /*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceLanding_style/* GiFooterWrap */.Dw, {
        "data-test-id": "InsuranceCommonLanding-GiFooterWrap",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(growth_dweb_footer_esm/* Footer */.$, {
          data: giFooterData,
          adobe: "",
          "data-test-id": "InsuranceCommonLanding-Footer"
        })
      })]
    }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(CommonLandingPwaWrapper, {
      "data-test-id": "InsuranceCommonLanding-CommonLandingPwaWrapper",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HeroSection, {
        heading: heading,
        goToMyOrders: goToMyOrders,
        "data-test-id": "InsuranceCommonLanding-HeroSection"
      }), travelInsurance && /*#__PURE__*/(0,jsx_runtime.jsx)(HeaderCard, {
        data: travelInsurance,
        onClick: handleTravelInsuranceClick,
        "data-test-id": "InsuranceCommonLanding-HeaderCard"
      }), travelProtection && /*#__PURE__*/(0,jsx_runtime.jsx)(TravelPlans, {
        travelProtection: travelProtection,
        "data-test-id": "InsuranceCommonLanding-TravelPlans"
      }), offers && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.ExclusiveOffers, {
        data: offers,
        bgColor: Global/* theme.whiteText2 */.rS.whiteText2,
        padding: "0",
        "data-test-id": "InsuranceCommonLanding-ExclusiveOffers"
      })]
    })
  });
};

/* harmony default export */ const InsuranceCommonLanding_InsuranceCommonLanding = (InsuranceCommonLanding);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/InsuranceLanding/PreloadImages.tsx


const PreloadImages = pageProps => {
  (0,react.useEffect)(() => {
    // Extract image URLs to avoid complex expressions in dependency array
    const claimSettlementIcon = pageProps?.data?.claimSettlementText?.icon;
    const travelSearchBannerIcon = pageProps?.data?.travelSearchBanner?.icon;
    const secureTravData = pageProps?.data?.secureTravData;
    const secureTravImg0 = secureTravData?.[0]?.travImg;
    const secureTravImg1 = secureTravData?.[1]?.travImg; // Collect all image URLs

    const imageUrls = [];

    if (claimSettlementIcon) {
      imageUrls.push(claimSettlementIcon);
    }

    if (travelSearchBannerIcon) {
      imageUrls.push(travelSearchBannerIcon);
    }

    if (secureTravImg0) {
      imageUrls.push(secureTravImg0);
    }

    if (secureTravImg1) {
      imageUrls.push(secureTravImg1);
    } // Static image URLs


    const staticImages = ["https://tripmoneycmsimgak.mmtcdn.com/img/Frame_27565_cc0104059a.png", "https://tripmoneycmsimgak.mmtcdn.com/img/Search_Icon_ffe4fbfcc2.svg", "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_5d58cf6783.svg", "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Up_Blue_21102e8ed6.svg", "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Down_Blue_2e09571187.svg", "https://tripmoneycmsimgak.mmtcdn.com/img/Arrow_Up_Blue_db78b6056e.svg"];
    imageUrls.push(...staticImages); // Function to prefetch images

    const prefetchImages = () => {
      imageUrls.forEach(url => {
        const img = new Image();
        img.src = url;
      });
    }; // Wait for page to be stable (load event + idle callback)


    const loadImagesWhenStable = () => {
      if (window.requestIdleCallback) {
        // Use requestIdleCallback if available (modern browsers)
        window.requestIdleCallback(prefetchImages, {
          timeout: 2000
        });
      } else {
        // Fallback: wait a bit after load event
        setTimeout(prefetchImages, 1000);
      }
    }; // Check if page is already loaded


    if (document.readyState === "complete") {
      loadImagesWhenStable();
    } else {
      // Wait for page load event
      window.addEventListener("load", loadImagesWhenStable, {
        once: true
      });
    } // Cleanup


    return () => {
      window.removeEventListener("load", loadImagesWhenStable);
    };
  }, [pageProps?.data?.claimSettlementText?.icon, pageProps?.data?.travelSearchBanner?.icon, pageProps?.data?.secureTravData]); // Return null since we're not rendering anything

  return null;
};

/* harmony default export */ const InsuranceLanding_PreloadImages = (PreloadImages);
// EXTERNAL MODULE: ../../libs/insurance-landing-ui/src/lib/components/index.tsx + 12 modules
var components = __webpack_require__(51066);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/PartnerContextProvider.tsx
var PartnerContextProvider = __webpack_require__(58524);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/LandingFaq/LandingFaq.tsx + 1 modules
var LandingFaq = __webpack_require__(73517);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/InsuranceLanding/InsuranceBottomComp.tsx










const data = [{
  title: "Popular Flight Sectors",
  links: [{
    text: "Kolkata to Delhi Flight",
    url: "https://www.goibibo.com/flights/kolkata-to-delhi-flights/"
  }, {
    text: "Hyderabad to Delhi Flight",
    url: "https://www.goibibo.com/flights/hyderabad-to-delhi-flights/"
  }]
}];

const InsuranceBottomComp = ({
  bottomCompData,
  footerInfo
}) => {
  const context = (0,PartnerContextProvider/* usePartnerContext */.X)();
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const {
    TravelInsData,
    safeSecureTravel,
    whatsCovered,
    claimYourInsurance,
    testimonials,
    faq,
    seoFaq,
    customNumbers,
    crossSell,
    offers
  } = bottomCompData;
  const footerLinks = footerInfo?.filter(data => data.type === "section")?.map((item, index) => ({
    id: index.toString(),
    label: item.title || "",
    listPoints: item?.links?.map((link, i) => ({
      id: i.toString(),
      label: link.title || "",
      link: link.url || ""
    })) ?? [],
    icon: ""
  })) ?? [];
  const footerHeading = footerInfo?.find(data => data.type === "rich-text");
  const footerCopyrightData = footerInfo?.find(data => data.type === "footnote");
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [customNumbers && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.InsuranceStats, {
      data: customNumbers,
      "data-test-id": "InsuranceBottomComp-InsuranceStats"
    }), offers && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.ExclusiveOffers, {
      data: offers,
      "data-test-id": "InsuranceBottomComp-ExclusiveOffers"
    }), TravelInsData && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.WhyBuyTravIns, {
      title: TravelInsData?.title,
      info: TravelInsData?.info,
      data: TravelInsData?.featureCard,
      "data-test-id": "InsuranceBottomComp-WhyBuyTravIns"
    }), safeSecureTravel && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.SafenSecureTrav, {
      data: safeSecureTravel?.safeTravCrd,
      title: safeSecureTravel?.title,
      "data-test-id": "InsuranceBottomComp-SafenSecureTrav"
    }), whatsCovered && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.WhatsCovered, {
      data: whatsCovered?.travCrd,
      title: whatsCovered?.title,
      info: whatsCovered?.info,
      "data-test-id": "InsuranceBottomComp-WhatsCovered"
    }), claimYourInsurance && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.ClaimYourInsurance, {
      title: claimYourInsurance.title,
      info: claimYourInsurance?.info,
      data: claimYourInsurance?.claimData,
      "data-test-id": "InsuranceBottomComp-ClaimYourInsurance"
    }), device == "lg" && crossSell && /*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceLanding_style/* PersuasionWrapper */.js, {
      "data-test-id": "InsuranceBottomComp-PersuasionWrapper",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.PersuasionBannerInsurance, {
        crossSell: crossSell,
        btnHandler: () => {
          context === src.PARTNER.GI ? window.open("https://tripmoney.goibibo.com/partners/gi/forex/listing?utm_source=insurance_gi&utm_medium=desktop", "_blank") : window.open("https://www.makemytrip.com/forex", "_blank");
        } // info={persuasionBannerMob.info}
        ,
        "data-test-id": "InsuranceBottomComp-PersuasionBannerInsurance"
      })
    }), testimonials && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.LandingTestimonials, {
      customTitle: testimonials?.title,
      test: testimonials?.testimonialData,
      "data-test-id": "InsuranceBottomComp-LandingTestimonials"
    }), (faq || seoFaq) && /*#__PURE__*/(0,jsx_runtime.jsx)(LandingFaq/* default */.Z, {
      customTitle: seoFaq?.title || faq?.title,
      faq: seoFaq?.faqList || faq?.faqList,
      customInfo: seoFaq?.info || faq?.info,
      icon: seoFaq?.icon || faq?.icon,
      "data-test-id": "InsuranceBottomComp-LandingFaq"
    }), context === src.PARTNER.GI && device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceLanding_style/* GiFooterWrap */.Dw, {
      "data-test-id": "InsuranceBottomComp-GiFooterWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(growth_dweb_footer_esm/* Footer */.$, {
        data: data,
        adobe: "",
        "data-test-id": "InsuranceBottomComp-Footer"
      })
    }) : /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.LandingFooter, {
      footerData: footerLinks,
      footerHeading: footerHeading,
      footerCopyrightData: footerCopyrightData,
      "data-test-id": "InsuranceBottomComp-LandingFooter"
    })]
  });
};

/* harmony default export */ const InsuranceLanding_InsuranceBottomComp = (InsuranceBottomComp);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/Shimmer/Shimmer.tsx
var Shimmer = __webpack_require__(83531);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/InsuranceLanding/InsuranceLandingShimmer.tsx





 //import Header from 'gi-happy-header/ssr/header';
//import { Header  } from 'pwa-mmt-ui-header/ssr/header';




const InsuranceLandingShimmer = () => {
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.DesktopLayout, {
      alignCenter: true,
      rightSectionHeight: "unset",
      leftSectionHeight: true,
      landingMargin: true,
      leftComp: /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(static_components.FlexComp, {
          gap: "8px",
          flexDirection: "column",
          "data-test-id": "InsuranceLandingShimmer-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Shimmer/* default */.Z, {
            height: "55px",
            width: device == "lg" ? "375px" : "100px",
            "data-test-id": "InsuranceLandingShimmer-Shimmer"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Shimmer/* default */.Z, {
            height: "55px",
            width: "100%",
            "data-test-id": "InsuranceLandingShimmer-Shimmer"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Shimmer/* default */.Z, {
          height: device == "lg" ? "20px" : "10px",
          width: device == "lg" ? "248px" : "100%",
          "data-test-id": "InsuranceLandingShimmer-Shimmer"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Shimmer/* default */.Z, {
          height: device == "lg" ? "80px" : "40px",
          width: "100%",
          "data-test-id": "InsuranceLandingShimmer-Shimmer"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(Shimmer/* default */.Z, {
          height: device == "lg" ? "80px" : "40px",
          width: "100%",
          "data-test-id": "InsuranceLandingShimmer-Shimmer"
        })]
      }),
      rightComp: /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.TravellingToShimmer, {
        "data-test-id": "InsuranceLandingShimmer-TravellingToShimmer"
      }),
      "data-test-id": "InsuranceLandingShimmer-DesktopLayout"
    })
  });
};

/* harmony default export */ const InsuranceLanding_InsuranceLandingShimmer = (InsuranceLandingShimmer);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/MyCash/MyCash.tsx + 1 modules
var MyCash = __webpack_require__(53089);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/ProductInfoSection/ProductInfoSection.tsx + 1 modules
var ProductInfoSection = __webpack_require__(85544);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/InsuranceLanding/InsuranceLanding.tsx


function InsuranceLanding_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function InsuranceLanding_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? InsuranceLanding_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : InsuranceLanding_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

 // import "pwa-mmt-ui-header/ssr/header.css";





















const InsuranceLanding_analytics = (0,insurance/* getAnalytics */.I)();

const InsuranceLanding = ({
  data,
  setActiveModal,
  query
}) => {
  const context = (0,PartnerContextProvider/* usePartnerContext */.X)();
  const {
    type
  } = (0,ui_src/* usePlanType */.U)();
  const experiment = (0,react.useContext)(ui_widgets_src/* ExperimentTrackingString */.Mq) || "";
  const isLandingPageRender = (0,react.useRef)(false);
  if (!data) return /*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceLanding_InsuranceLandingShimmer, {
    "data-test-id": "InsuranceLanding-InsuranceLandingShimmer"
  });
  const {
    title,
    isRegionSupported,
    claimSettlementText,
    secureTravData,
    travellingTo,
    calendarDatesLimit,
    upcomingTrip,
    upcomingTripsV2,
    errorFields,
    offeredBy,
    footer,
    seoFooter,
    travelSearchBanner,
    nextPageRoute,
    chatBotInfo,
    productInfoBanner,
    myPartnerGroupInsuranceEnabled,
    myCashData,
    benefitsData,
    itineraryId,
    claimYourInsurance,
    crossSell,
    testimonials,
    seoContent
  } = data;
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const partner = (0,utils/* getPartnerOnClientSide */.et)();
  const isMyPartnerClient = (0,utils/* isMyPartner */.bR)();
  (0,react.useEffect)(() => {
    if (itineraryId) {
      (0,utils/* replaceHistory */.df)("itineraryId", itineraryId);
    }

    InsuranceLanding_analytics?.trackPageLoadEvent({
      pageName: "LANDING",
      experiment
    }, type);
    const {
      value = []
    } = travellingTo?.travelSearchForm?.regionCountryList || {};
    const queryParams = new URLSearchParams(window.location.search);
    const selectedCountries = query?.countries || queryParams.get("countries");
    const selectedCountryCodes = selectedCountries?.split(",");
    const subpageName = queryParams.get("type") || query?.type;
    let totalCountryData = value?.map(data => {
      if (selectedCountryCodes?.includes(data.code)) {
        return InsuranceLanding_objectSpread(InsuranceLanding_objectSpread({}, data), {}, {
          isSelected: true
        });
      }

      return InsuranceLanding_objectSpread({}, data);
    });
    const selectedCountry = totalCountryData?.filter(item => item.isSelected);

    if (value?.length) {
      localStorage.setItem("TRAVEL_INSURANCE_COUNTRIES", JSON.stringify(totalCountryData));
    }

    if (!isLandingPageRender.current) {
      (0,XDMAnalytics.initializePageTracking)({
        page_context: InsuranceLanding_objectSpread({
          page_name: "landing",
          page_type: "landing",
          funnel_step: "landing"
        }, subpageName && {
          subpage_name: subpageName
        }) // experiment_details: {
        //   variant_keys: "44w",
        //   honoured_exp_list: [],
        // }

      }, {
        countries: selectedCountry ? selectedCountry : [],
        journeyType: query?.segment || queryParams.get("segment"),
        travellers: parseInt(query?.travellers || queryParams.get("travellers") || "1"),
        fromDateTime: query?.startDate || queryParams.get("startDate") ? parseInt(query?.startDate || queryParams.get("startDate") || "0") : 0,
        toDateTime: query?.endDate || queryParams.get("endDate") ? parseInt(query?.endDate || queryParams.get("endDate") || "0") : 0
      });
      isLandingPageRender.current = true;
    }

    return () => {
      (0,XDMAnalytics.triggerPageExit)();
    };
  }, []);

  const goToMyOrders = () => {
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "my_orders_clicked"
      }
    });
    InsuranceLanding_analytics?.trackLandingEvents({
      actionType: "my_orders_clicked"
    }, "pageView", type);
    const authCookie = (0,utils/* getCookieByName */.A7)("mmt-auth") || (0,utils/* getCookieByName */.A7)("OAUTH-GOIBIBO");

    if (authCookie) {
      if (data?.myOrderBtnLink) {
        window.location.href = data?.myOrderBtnLink;
      } else {
        navigation/* navigationActions.navigateToOrderListing */.ej.navigateToOrderListing();
      }
    } else {
      setActiveModal?.("LOGIN");
    }
  }; // Education modal tracking handlers


  const handleEducationModalShown = () => {
    InsuranceLanding_analytics?.trackLandingEvents?.({
      actionType: "educationModal_shown"
    }, "pageView", type);
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "educationModal_shown"
      }
    });
  };

  const handleEducationModalNextClick = () => {
    InsuranceLanding_analytics?.trackLandingEvents?.({
      actionType: "educationModal_next_click"
    }, "pageView", type);
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "educationModal_next_click"
      }
    });
  };

  const handleEducationModalSkipClick = () => {
    InsuranceLanding_analytics?.trackLandingEvents?.({
      actionType: "educationModal_skip_click"
    }, "pageView", type);
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "educationModal_skip_click"
      }
    });
  };

  const handleEducationModalPageShown = pageId => {
    InsuranceLanding_analytics?.trackLandingEvents?.({
      actionType: `educationModal_${pageId}_shown`
    }, "pageView", type);
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: `educationModal_${pageId}_shown`
      }
    });
  };

  const handleProductInfoKnowMoreClick = () => {
    InsuranceLanding_analytics?.trackLandingEvents?.({
      actionType: "productInfo_knowMore_clicked"
    }, "pageView", type);
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "productInfo_knowMore_clicked"
      }
    });
  };

  const handleProductInfoCardClick = () => {
    InsuranceLanding_analytics?.trackLandingEvents?.({
      actionType: "productInfo_card_clicked"
    }, "pageView", type);
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "productInfo_card_clicked"
      }
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceLanding_PreloadImages, {
      data: data,
      "data-test-id": "InsuranceLanding-PreloadImages"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.DesktopLayout, {
      pageName: "LANDING",
      landingPageProp: type ? false : true,
      title: title,
      height: device == "lg" ? "720px" : "",
      rightSectionHeight: "unset",
      leftSectionHeight: true,
      landingMargin: type ? false : true,
      goToMyOrders: goToMyOrders,
      chatBotInfo: chatBotInfo,
      showMyOrder: !travellingTo?.travellerInfoSection && partner !== src.PARTNER.MYBIZ,
      leftPositionSticky: type || partner === src.PARTNER.MYBIZ ? false : true,
      leftComp: /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(static_components.FlexComp, {
          margin: device == "sm" ? "0 0 0px" : context ? "-30px 0 0" : "",
          alignItems: "center",
          gap: "6px",
          "data-test-id": "InsuranceLanding-FlexComp",
          children: offeredBy ? /*#__PURE__*/(0,jsx_runtime.jsxs)(static_components.FlexComp, {
            flexDirection: "column" // alignItems="center"
            ,
            margin: "10px 0px 0px 0px",
            "data-test-id": "InsuranceLanding-FlexComp",
            children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(static_components.FlexComp, {
              gap: "4px",
              "data-test-id": "InsuranceLanding-FlexComp",
              children: [offeredBy?.title && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.SpanTag, {
                fontWeight: "bold",
                "data-test-id": "InsuranceLanding-SpanTag",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.FormattedText, {
                  value: offeredBy?.title,
                  "data-test-id": "InsuranceLanding-FormattedText"
                })
              }), offeredBy?.icons?.map((url, index) => {
                return /*#__PURE__*/(0,jsx_runtime.jsxs)(static_components.FlexComp, {
                  gap: "10px",
                  "data-test-id": "InsuranceLanding-FlexComp",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)(static_components.ImageComponent, {
                    height: "22px",
                    width: "auto",
                    src: url,
                    loading: "eager",
                    "data-test-id": `InsuranceLanding-ImageComponent-${url}`
                  }, url), index !== offeredBy?.icons?.length - 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceLanding_style/* HorizontalDivider */.EL, {
                    height: "22px",
                    width: "1px",
                    backgroundColor: "#979797",
                    "data-test-id": "InsuranceLanding-HorizontalDivider"
                  })]
                });
              })]
            }), offeredBy?.description && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.SpanTag, {
              fontSize: "xs",
              "data-test-id": "InsuranceLanding-SpanTag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.FormattedText, {
                value: offeredBy?.description,
                "data-test-id": "InsuranceLanding-FormattedText"
              })
            })]
          }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(static_components.ImageComponent, {
              width: "12px",
              height: "16px",
              src: claimSettlementText?.icon,
              loading: "eager",
              "data-test-id": "InsuranceLanding-ImageComponent"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.SpanTag, {
              fontSize: "xs",
              fontWeight: "bold",
              color: Global/* theme.blackText */.rS.blackText,
              "data-test-id": "InsuranceLanding-SpanTag",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.FormattedText, {
                value: claimSettlementText.title,
                "data-test-id": "InsuranceLanding-FormattedText"
              })
            })]
          })
        }), device == "lg" && secureTravData && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.SecureTravOffer, {
          data: secureTravData,
          "data-test-id": "InsuranceLanding-SecureTravOffer"
        }), isMyPartnerClient && myCashData && /*#__PURE__*/(0,jsx_runtime.jsx)(MyCash/* default */.Z, InsuranceLanding_objectSpread(InsuranceLanding_objectSpread({}, myCashData), {}, {
          "data-test-id": "InsuranceLanding-MyCash"
        })), productInfoBanner && /*#__PURE__*/(0,jsx_runtime.jsx)(ProductInfoSection/* default */.Z, {
          productInfoBanner: productInfoBanner,
          onEducationModalShown: handleEducationModalShown,
          onEducationModalNextClick: handleEducationModalNextClick,
          onEducationModalSkipClick: handleEducationModalSkipClick,
          onEducationModalPageShown: handleEducationModalPageShown,
          onKnowMoreClick: handleProductInfoKnowMoreClick,
          onProductCardClick: handleProductInfoCardClick,
          "data-test-id": "InsuranceLanding-ProductInfoSection"
        }), isMyPartnerClient && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.LandingBenefits, {
          benefitsDataList: benefitsData,
          "data-test-id": "InsuranceLanding-LandingBenefits"
        })]
      }),
      rightComp: /*#__PURE__*/(0,jsx_runtime.jsxs)(InsuranceLanding_style/* LandingPageRightWrapper */.Pc, {
        rightCompMargin: type ? true : false,
        "data-test-id": "InsuranceLanding-LandingPageRightWrapper",
        children: [upcomingTripsV2 && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.DomesticTrip, {
          title: upcomingTripsV2?.title,
          trips: upcomingTripsV2?.trips,
          "data-test-id": "InsuranceLanding-DomesticTrip"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.TravellingTo, {
          travelSearchBanner: travelSearchBanner,
          travellingToSection: travellingTo,
          upcomingTrip: upcomingTrip,
          calendarDatesLimit: calendarDatesLimit,
          nextPageRoute: nextPageRoute,
          errorFields: errorFields,
          myPartnerGroupInsuranceEnabled: myPartnerGroupInsuranceEnabled,
          query: query,
          "data-test-id": "InsuranceLanding-TravellingTo"
        }), device != "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.SecureTravOffer, {
          data: secureTravData,
          "data-test-id": "InsuranceLanding-SecureTravOffer"
        }), testimonials && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.LandingTestimonials, {
          customTitle: testimonials?.title,
          test: testimonials?.testimonialData,
          "data-test-id": "InsuranceLanding-LandingTestimonials"
        }), seoContent && /*#__PURE__*/(0,jsx_runtime.jsx)(components.SeoContent, {
          seoContent: seoContent,
          "data-test-id": "InsuranceLanding-SeoContent"
        })]
      }),
      bottomComp: /*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceLanding_InsuranceBottomComp, {
        bottomCompData: data,
        footerInfo: seoFooter || footer,
        "data-test-id": "InsuranceLanding-InsuranceBottomComp"
      }),
      "data-test-id": "InsuranceLanding-DesktopLayout"
    })]
  });
};

/* harmony default export */ const InsuranceLanding_InsuranceLanding = (InsuranceLanding);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/utils/index.tsx
var static_utils = __webpack_require__(84576);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/InsuranceListing/InsuranceListing/InsuranceListing.tsx


function InsuranceListing_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function InsuranceListing_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? InsuranceListing_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : InsuranceListing_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

// import "pwa-mmt-ui-header/ssr/header.css";











const InsuranceListing_analytics = (0,insurance/* getAnalytics */.I)();

const InsuranceListing = ({
  listingData
}) => {
  const {
    title,
    choosePlan,
    priceData,
    planData,
    cards,
    filterList = [],
    compareToast,
    comparePlansV2,
    showPlanData,
    travelDetails,
    chatBotInfo,
    productInfoBanner,
    disclaimer
  } = listingData;
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const {
    0: country,
    1: setCountry
  } = (0,react.useState)("");
  const {
    0: travelDate,
    1: setTravelDate
  } = (0,react.useState)();
  const {
    0: travellers,
    1: setTravellers
  } = (0,react.useState)("");
  const {
    0: quickFilters,
    1: setQuickFilters
  } = (0,react.useState)();
  const displayFilters = filterList[0];
  const experiment = (0,react.useContext)(ui_widgets_src/* ExperimentTrackingString */.Mq) || "";
  const {
    type
  } = (0,ui_src/* usePlanType */.U)();
  (0,react.useEffect)(() => {
    if (filterList) {
      const transformedFilters = displayFilters?.filters?.map((filter, index) => InsuranceListing_objectSpread(InsuranceListing_objectSpread({}, filter), {}, {
        id: index.toString(),
        name: filter.title
      }));
      setQuickFilters(transformedFilters);
    } else {
      const priceFilters = priceData?.map(filter => {
        return InsuranceListing_objectSpread(InsuranceListing_objectSpread({}, filter), {}, {
          isSelected: filter.name === "All" ? true : false
        });
      });
      setQuickFilters(priceFilters);
    }
  }, []);
  (0,react.useEffect)(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const segment = queryParams.get("segment");
    const startDate = queryParams.get("startDate");
    const endDate = queryParams.get("endDate");
    const travellers = queryParams.get("travellers");
    const countries = travelDetails && travelDetails.countries ? travelDetails.countries : queryParams.get("countries");
    const subpageName = queryParams.get("type");
    countries && setCountry(countries.split(",").join(", "));
    setTravellers(travellers);
    let start, end;

    if (startDate && endDate) {
      start = (0,static_utils/* convertUnixToDate */.P9)(Number(startDate));
      end = (0,static_utils/* convertUnixToDate */.P9)(Number(endDate));
      setTravelDate({
        startDate: start,
        endDate: end
      });
    }

    InsuranceListing_analytics?.trackPageLoadEvent({
      pageName: "LISTING",
      country: countries || "",
      startDate: start?.toLocaleDateString("en-GB")?.replace(/\//gi, ":"),
      endDate: end?.toLocaleDateString("en-GB")?.replace(/\//gi, ":"),
      travellers: `${Number(travellers)}|0|0`,
      segment: segment || "",
      experiment
    }, type);
    let selectedCountries = [];

    if (countries) {
      selectedCountries = (0,XDMAnalytics.getSelectedCountriesFromLocalStorage)(queryParams.get("countries")?.split(",") || []);
    }

    (0,XDMAnalytics.initializePageTracking)({
      page_context: InsuranceListing_objectSpread({
        page_name: "listing",
        page_type: "funnel",
        funnel_step: "listing"
      }, subpageName && {
        subpage_name: subpageName
      })
    }, {
      countries: selectedCountries,
      journeyType: segment || "",
      travellers: travellers ? parseInt(travellers) : 1,
      fromDateTime: start ? start.getTime() / 1000 : 0,
      toDateTime: end ? end.getTime() / 1000 : 0
    });
    return () => {
      (0,XDMAnalytics.triggerPageExit)();
    };
  }, []);

  const handleEducationModalShown = () => {
    InsuranceListing_analytics?.trackListingEvents?.({
      actionType: "educationModal_shown"
    }, "pageView", type);
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "educationModal_shown"
      }
    });
  };

  const handleEducationModalNextClick = () => {
    InsuranceListing_analytics?.trackListingEvents?.({
      actionType: "educationModal_next_click"
    }, "pageView", type);
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "educationModal_next_click"
      }
    });
  };

  const handleEducationModalSkipClick = () => {
    InsuranceListing_analytics?.trackListingEvents?.({
      actionType: "educationModal_skip_click"
    }, "pageView", type);
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "educationModal_skip_click"
      }
    });
  };

  const handleEducationModalPageShown = pageId => {
    InsuranceListing_analytics?.trackListingEvents?.({
      actionType: `educationModal_${pageId}_shown`
    }, "pageView", type);
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: `educationModal_${pageId}_shown`
      }
    });
  };

  const handleProductInfoKnowMoreClick = () => {
    InsuranceListing_analytics?.trackListingEvents?.({
      actionType: "productInfo_knowMore_clicked"
    }, "pageView", type);
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "productInfo_knowMore_clicked"
      }
    });
  };

  const handleProductInfoCardClick = () => {
    InsuranceListing_analytics?.trackListingEvents?.({
      actionType: "productInfo_card_clicked"
    }, "pageView", type);
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "productInfo_card_clicked"
      }
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.DesktopLayout, {
      pageName: "LISTING",
      chatbotBottomMargin: 120,
      title: title,
      chatBotInfo: chatBotInfo,
      leftComp: /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(static_components.ListingEditDetails, {
          title: country,
          travelDates: travelDate,
          travellerCount: Number(travellers) || 1,
          showEditIcon: true,
          "data-test-id": "InsuranceListing-ListingEditDetails"
        }), device == "lg" && showPlanData && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.ShowInsPlan, {
          data: showPlanData,
          "data-test-id": "InsuranceListing-ShowInsPlan"
        }), device == "lg" && productInfoBanner && /*#__PURE__*/(0,jsx_runtime.jsx)(ProductInfoSection/* default */.Z, {
          productInfoBanner: productInfoBanner,
          onEducationModalShown: handleEducationModalShown,
          onEducationModalNextClick: handleEducationModalNextClick,
          onEducationModalSkipClick: handleEducationModalSkipClick,
          onEducationModalPageShown: handleEducationModalPageShown,
          onKnowMoreClick: handleProductInfoKnowMoreClick,
          onProductCardClick: handleProductInfoCardClick,
          "data-test-id": "InsuranceListing-ProductInfoSection"
        }), device == "lg" && disclaimer && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.FormattedText, {
          baseStyle: {
            color: Global/* theme.greyText */.rS.greyText,
            fontSize: "14px",
            fontWeight: "400"
          },
          value: disclaimer,
          "data-test-id": "InsuranceListing-FormattedText"
        })]
      }),
      rightComp: /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.InsurancePlans, {
          travelDetails: travelDetails,
          title: choosePlan?.planTitle,
          data: cards ? cards : planData,
          tagData: quickFilters ? quickFilters : priceData,
          quickFiltersTitle: `${displayFilters?.filterTitle || ""} ${displayFilters?.filterSubtitle || ""}`,
          quickFilters: quickFilters,
          setQuickFilters: setQuickFilters,
          compareToastData: compareToast,
          comparePlan: comparePlansV2 // TODO: we will integrate this once we add filters
          // sortnFilterTxt={
          //     listingMockData?.choosePlan?.sortnFilterTxt
          // }
          ,
          "data-test-id": "InsuranceListing-InsurancePlans"
        })
      }) // bottomComp={ <LandingFooter
      //     playStoreImgURI={playStoreImg.src}
      //     appStoreImgURI={appStoreImg.src}
      //     facebookImgURI={facebookImg.src}
      //     linkedInImgURI={linkedInImg.src}
      //     twitterImgURI={twitterImg.src}
      //     footerData={footerData}
      // />}
      ,
      "data-test-id": "InsuranceListing-DesktopLayout"
    })
  });
};

/* harmony default export */ const InsuranceListing_InsuranceListing = (InsuranceListing);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/mypartner/index.ts + 10 modules
var mypartner = __webpack_require__(39363);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/mypartner/contexts/FilterContext.tsx
var FilterContext = __webpack_require__(22841);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/InsuranceListing/InsuranceListingV2/InsuranceListingV2.styles.ts

const ListingLayoutV2 = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceListingV2styles__ListingLayoutV2",
  componentId: "sc-11i088c-0"
})(["width:100%;min-height:100vh;padding:50px 0 0 0;box-sizing:border-box;background-image:linear-gradient(180deg,#282a47 0.38%,#554276 100%);background-size:100% 157px;background-color:#f4f4f4;background-repeat:no-repeat;padding-top:16px;position:relative;z-index:2;.userSection{img,picture{flex-shrink:1;}}height:100%;"]);
const HeadComp = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceListingV2styles__HeadComp",
  componentId: "sc-11i088c-1"
})(["width:1192px;margin:0 auto 10px auto;"]);
const MainContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceListingV2styles__MainContainer",
  componentId: "sc-11i088c-2"
})(["margin:0 auto;width:1192px;display:flex;justify-content:space-between;gap:12px;"]);
const LeftComp = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceListingV2styles__LeftComp",
  componentId: "sc-11i088c-3"
})(["width:320px;gap:12px;display:flex;flex-direction:column;"]);
const RightComp = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceListingV2styles__RightComp",
  componentId: "sc-11i088c-4"
})(["width:860px;gap:12px;display:flex;flex-direction:column;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/InsuranceListing/InsuranceListingV2/InsuranceListingV2.tsx


function InsuranceListingV2_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function InsuranceListingV2_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? InsuranceListingV2_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : InsuranceListingV2_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }












const InsuranceListingV2 = ({
  listingData
}) => {
  const {
    components,
    pageData
  } = listingData;
  const analytics = (0,insurance/* getAnalytics */.I)();
  (0,react.useEffect)(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const segment = queryParams.get("segment");
    const startDate = queryParams.get("startDate");
    const endDate = queryParams.get("endDate");
    const travellers = queryParams.get("travellers");
    const countries = queryParams.get("countries");
    const subpageName = queryParams.get("type");
    analytics?.trackPageLoadEvent({
      pageName: "LISTING",
      experiment: pageData?.experiment
    });
    let selectedCountries = [];

    if (countries) {
      selectedCountries = (0,XDMAnalytics.getSelectedCountriesFromLocalStorage)(queryParams.get("countries")?.split(",") || []);
    }

    let start, end;

    if (startDate && endDate) {
      start = (0,utils/* convertUnixToDate */.P9)(Number(startDate));
      end = (0,utils/* convertUnixToDate */.P9)(Number(endDate));
    }

    (0,XDMAnalytics.initializePageTracking)({
      page_context: InsuranceListingV2_objectSpread({
        page_name: "listing",
        page_type: "funnel",
        funnel_step: "listing"
      }, subpageName && {
        subpage_name: `${subpageName}_mypartner`
      })
    }, {
      countries: selectedCountries,
      journeyType: segment || "",
      travellers: travellers ? parseInt(travellers) : 1,
      fromDateTime: start ? start.getTime() / 1000 : 0,
      toDateTime: end ? end.getTime() / 1000 : 0
    });
    return () => {
      (0,XDMAnalytics.triggerPageExit)();
    };
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(FilterContext/* FilterProvider */.hz, {
    "data-test-id": "InsuranceListingV2-FilterProvider",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ListingLayoutV2, {
      id: "pageId",
      "data-test-id": "InsuranceListingV2-ListingLayoutV2",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(HeadComp, {
        "data-test-id": "InsuranceListingV2-HeadComp",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(static_components.BreadcrumbComponent, {
          "data-test-id": "InsuranceListingV2-BreadcrumbComponent"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(mypartner/* ComponentRenderer */.O, {
          components: components,
          layout: "top",
          "data-test-id": "InsuranceListingV2-ComponentRenderer"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(MainContainer, {
        "data-test-id": "InsuranceListingV2-MainContainer",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(LeftComp, {
          "data-test-id": "InsuranceListingV2-LeftComp",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(mypartner/* ComponentRenderer */.O, {
            components: components,
            layout: "left",
            "data-test-id": "InsuranceListingV2-ComponentRenderer"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(RightComp, {
          "data-test-id": "InsuranceListingV2-RightComp",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(mypartner/* ComponentRenderer */.O, {
            components: components,
            csrfToken: pageData?.csrfToken,
            layout: "right",
            "data-test-id": "InsuranceListingV2-ComponentRenderer"
          })
        })]
      })]
    })
  });
};

/* harmony default export */ const InsuranceListingV2_InsuranceListingV2 = (InsuranceListingV2);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/InsuranceListing/InsuranceListingWrapper.tsx


function InsuranceListingWrapper_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function InsuranceListingWrapper_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? InsuranceListingWrapper_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : InsuranceListingWrapper_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








const InsuranceListingWrapper = props => {
  const partner = (0,utils/* getPartnerOnClientSide */.et)();
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: partner === src.PARTNER.MYPARTNER ? /*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceListingV2_InsuranceListingV2, InsuranceListingWrapper_objectSpread(InsuranceListingWrapper_objectSpread({}, props), {}, {
      "data-test-id": "InsuranceListingWrapper-InsuranceListingV2"
    })) : /*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceListing_InsuranceListing, {
      listingData: props.listingData,
      "data-test-id": "InsuranceListingWrapper-InsuranceListing"
    })
  });
};

/* harmony default export */ const InsuranceListing_InsuranceListingWrapper = (InsuranceListingWrapper);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/icons/index.ts + 7 modules
var icons = __webpack_require__(64204);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/InsurancePaySuccess/InsurancePaySuccess.tsx









const InsurancePaySuccess_analytics = (0,insurance/* getAnalytics */.I)();

const InsurancePaySuccess = () => {
  const {
    0: paymentMethod,
    1: setPaymentMethod
  } = (0,react.useState)("");
  const {
    0: bookingId,
    1: setBookingId
  } = (0,react.useState)("");
  const {
    0: refId,
    1: setRefId
  } = (0,react.useState)("");
  const {
    type
  } = (0,ui_src/* usePlanType */.U)();
  (0,react.useEffect)(() => {
    InsurancePaySuccess_analytics?.trackPageLoadEvent({
      pageName: "PAYMENT",
      bookingStatus: "success"
    }); // const queryParams = new URLSearchParams(window.location.search);
    // const bookingId = queryParams.get("bookingId");
    // const paymentMethod = queryParams.get("paymentMethod");
    // initializePageTracking(
    //   {
    //     page_context: {
    //       page_name: "payment",
    //       page_type: "funnel",
    //       funnel_step: "thankyou",
    //       subpage_name: "payment_success",
    //     },
    //     event_detail: {
    //       booking_info: {
    //         booking_id: bookingId || "",
    //         status: "success",
    //         payment_method: paymentMethod || "",
    //       },
    //     },
    //   },
    //   {
    //     isReadStoreSearchContext: true,
    //   }
    // );
  }, []);
  (0,react.useEffect)(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const passportRequired = queryParams.get("passportRequired");
    const paymentMethod = queryParams.get("paymentMethod");
    setPaymentMethod(paymentMethod);
    const bookingId = queryParams.get("bookingId");
    setBookingId(bookingId);
    const itineraryId = queryParams.get("itineraryId");
    const refId = queryParams.get("refId");
    setRefId(refId);
    (0,utils/* setTravDetailsInMemory */.Yp)({});
    const timer = setTimeout(() => {
      if (passportRequired === "true") {
        navigation/* navigationActions.navigateToAddPassport */.ej.navigateToAddPassport({
          bookingId,
          pageId: src.PASSPORT_DETAILS_PAGE_ID.PAYMENT_SUCCESS
        });
      } else {
        navigation/* navigationActions.navigateToOrderConfirmed */.ej.navigateToOrderConfirmed({
          bookingId,
          type: type || "",
          itineraryId: itineraryId || ""
        });
      }
    }, src.TXN_SUCCESS_REDIRECT_TIME);
    return () => {
      clearTimeout(timer);
    };
  }, [bookingId]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.PaymentStatusComp, {
      title: "Payment Successful",
      infoTxt: `${paymentMethod ? `Paid using: ${paymentMethod}` : ""}`,
      subInfoTxt: `${refId ? `Ref. Number: ${refId}` : ""}`,
      imageIcon: /*#__PURE__*/(0,jsx_runtime.jsx)(icons/* Confetti */.DI, {
        "data-test-id": "InsurancePaySuccess-Confetti"
      }),
      "data-test-id": "InsurancePaySuccess-PaymentStatusComp"
    })
  });
};

/* harmony default export */ const InsurancePaySuccess_InsurancePaySuccess = (InsurancePaySuccess);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/InsuranceTravellerDetail/InsuranceTravellerDetail/travellerDetailMockData.ts
const travellerDetailData = {
  title: {
    text: {
      value: "Add Travellers"
    }
  },
  travellerPlanInfo: {
    icon: "https://tripmoneycmsimgak.mmtcdn.com/img/Group_5273_1299494d83.png",
    title: "Great Choice!",
    text: [{
      value: "90% of the travellers to Thailand ",
      styles: {
        color: "#fff",
        fontWeight: "bold"
      }
    }, {
      value: "have bought this Insurance",
      styles: {
        color: "#fff"
      }
    }]
  },
  planInfo: {
    planType: {
      text: {
        value: "INSURANCE",
        styles: {
          color: "#CC2C64"
        }
      }
    },
    planName: {
      text: {
        value: "Tripmoney Tourer Plus Advanced Insurance",
        styles: {
          color: "#fff"
        }
      }
    },
    sumInsured: {
      text: {
        value: "Sum Insured Per Person: $ 50,000",
        styles: {
          color: "#fff"
        }
      }
    },
    amountToPay: {
      text: [{
        value: "Amount to pay :  ",
        styles: null
      }, {
        value: "₹ 498",
        styles: {}
      }]
    }
  },
  travellerDetail: {
    title: "Add Traveller Details",
    info: "Senior citizens 70yrs and above are not covered"
  },
  primaryContact: {
    title: "Primary Contact Details",
    info: "All the communication regarding to the insurance will be shared to this contact.",
    fields: {
      mobile: {
        countryCode: "91",
        errorMessage: "Please enter valid Mobile No.",
        placeholder: "Enter 10 Digit Mobile No.",
        fieldName: "mobile",
        isRequired: true,
        regex: "^[1-9][0-9]{5,14}$",
        title: "10 Digit Mobile No.",
        value: "6460672974"
      },
      email: {
        errorMessage: "Please enter valid email",
        fieldName: "email",
        isRequired: true,
        regex: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$",
        title: "Email ID",
        placeholder: "Enter Email ID",
        value: "goodmanwatches@gmail.com"
      }
    }
  },
  secondaryContact: {
    title: "Traveller",
    fields: {
      name: {
        errorMessage: "Please enter valid Name",
        fieldName: "Name",
        placeholder: "Full Name",
        isRequired: true,
        regex: "^.{3,}$",
        title: "FULL NAME",
        value: ""
      },
      dob: {
        errorMessage: "Please enter valid Date of Birth",
        fieldName: "DOB",
        isRequired: true,
        regex: "^(?:0[1-9]|[12]\\d|3[01])([/.-])(?:0[1-9]|1[012])\\1(?:19|20)\\d\\d$",
        title: "DATE OF BIRTH",
        placeholder: "dd/mm/yyy",
        value: ""
      },
      gender: {
        fieldName: "Gender",
        isRequired: true,
        title: "Gender",
        values: [{
          label: "Male",
          id: "1",
          isSelected: false
        }, {
          label: "Female",
          id: "2",
          isSelected: false
        }, {
          label: "Others",
          id: "3",
          isSelected: false
        }]
      }
    }
  },
  concent: {
    tnc: {
      title: {
        text: [{
          value: "By Proceeding, I confirm that all travellers are Indian Citizens & below 70 years of age. Also, I agree to all the ",
          styles: null
        }, {
          value: "Terms & Conditions.",
          styles: null
        }]
      },
      url: ""
    },
    info: "Go-MMT hereby disclaims warranties of any kind, whether express or implied, including the warranty of title, merchantability, non-infringement and fitness for a particular purpose with regard to the travel insurances available on its platform. Go-MMT makes available the travel insurance as a group administrator and thus, Go-MMT is not responsible and liable for the travel insurance policies provided by the insurance providers."
  },
  note: {
    title: {
      text: {
        value: "Please note*",
        styles: {}
      }
    },
    info: {
      text: {
        value: "The passport details and nominee details have to be added post insurance purchase to generate the policy document.",
        styles: null
      }
    }
  },
  upcomingTravellerDetails: [{
    name: "Anusha",
    dob: "",
    gender: "Female"
  }],
  tnc: {
    title: "T&C Apply",
    url: "https://www.google.com"
  },
  totalAmt: "₹ 498"
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/InsuranceTravellerDetail/InsuranceTravellerDetail/InsuranceTravellerDetailShimmer.tsx






const InsuranceTravellerDetailShimmer = () => {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(static_components.LandingHeader, {
      loginState: true,
      "data-test-id": "InsuranceTravellerDetailShimmer-LandingHeader"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.DesktopLayout, {
      title: travellerDetailData?.title,
      shimmer: true,
      leftComp: /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(static_components.Shimmer, {
          width: "100%",
          height: "112px",
          "data-test-id": "InsuranceTravellerDetailShimmer-Shimmer"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.Shimmer, {
          width: "100%",
          height: "112px",
          "data-test-id": "InsuranceTravellerDetailShimmer-Shimmer"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.GreatChoiceShimmer, {
          "data-test-id": "InsuranceTravellerDetailShimmer-GreatChoiceShimmer"
        })]
      }),
      rightComp: /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.AddTravellerDetailShimmer, {
          "data-test-id": "InsuranceTravellerDetailShimmer-AddTravellerDetailShimmer"
        })
      }),
      "data-test-id": "InsuranceTravellerDetailShimmer-DesktopLayout"
    })]
  });
};

/* harmony default export */ const InsuranceTravellerDetail_InsuranceTravellerDetailShimmer = (InsuranceTravellerDetailShimmer);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/InsuranceTravellerDetail/InsuranceTravellerDetail/utils.ts


function utils_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function utils_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? utils_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : utils_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

const getMoreBenefits = planBenefits => {
  const benefits = planBenefits?.benefits?.reduce?.((result, item) => {
    const key = item.name ?? "";
    const value = item.features?.map(item => {
      return {
        id: item?.key,
        icon: item?.icon,
        info: item?.description,
        title: item?.name,
        price: item?.cover
      };
    });
    return utils_objectSpread(utils_objectSpread({}, result), {}, {
      [key]: value
    });
  }, {});
  const benefitsData = {
    buyBtn: "BUY NOW",
    productId: "",
    quoteId: "",
    ctaLink: planBenefits?.tnc?.title,
    insAmount: planBenefits?.unitPrice,
    insPlanName: planBenefits?.subtitle,
    insuranceType: planBenefits?.title,
    moreBenefits: benefits,
    packName: planBenefits?.category,
    paxPerDay: planBenefits?.unitType,
    tncLink: planBenefits?.tnc?.url
  };
  return benefitsData;
};
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/PaymentFailedModal/PaymentFailedModal.tsx + 1 modules
var PaymentFailedModal = __webpack_require__(35722);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/InsuranceTravellerDetail/InsuranceTravellerDetail/countryData.ts
const COUNTRY_DATA = [{
  id: 1,
  countryName: "Afghanistan",
  countryCode: "+93",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/af_65f35b67e6.svg",
  isSelected: false
}, {
  id: 2,
  countryName: "Aland Islands",
  countryCode: "+358",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ax_f4cd25e58e.svg",
  isSelected: false
}, {
  id: 3,
  countryName: "Albania",
  countryCode: "+355",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/al_efd1cbc0cf.svg",
  isSelected: false
}, {
  id: 4,
  countryName: "Algeria",
  countryCode: "+213",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/dz_80cc45045a.svg",
  isSelected: false
}, {
  id: 5,
  countryName: "AmericanSamoa",
  countryCode: "+1684",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/as_aac4597df8.svg",
  isSelected: false
}, {
  id: 6,
  countryName: "Andorra",
  countryCode: "+376",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ad_ee7ad21ccc.svg",
  isSelected: false
}, {
  id: 7,
  countryName: "Angola",
  countryCode: "+244",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ao_9a43a6bf98.svg",
  isSelected: false
}, {
  id: 8,
  countryName: "Anguilla",
  countryCode: "+1264",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ai_32b586c5d9.svg",
  isSelected: false
}, {
  id: 9,
  countryName: "Antarctica",
  countryCode: "+672",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/aq_fd9751cdf5.svg",
  isSelected: false
}, {
  id: 10,
  countryName: "Antigua and Barbuda",
  countryCode: "+1268",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ag_450e12ec7d.svg",
  isSelected: false
}, {
  id: 11,
  countryName: "Argentina",
  countryCode: "+54",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ar_706cd7342f.svg",
  isSelected: false
}, {
  id: 12,
  countryName: "Armenia",
  countryCode: "+374",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/am_15cbae413a.svg",
  isSelected: false
}, {
  id: 13,
  countryName: "Aruba",
  countryCode: "+297",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/aw_ca8d081fe1.svg",
  isSelected: false
}, {
  id: 14,
  countryName: "Australia",
  countryCode: "+61",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/au_7474aabf80.svg",
  isSelected: false
}, {
  id: 15,
  countryName: "Austria",
  countryCode: "+43",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/at_96cc217bd8.svg",
  isSelected: false
}, {
  id: 16,
  countryName: "Azerbaijan",
  countryCode: "+994",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/az_0e3c127cd1.svg",
  isSelected: false
}, {
  id: 17,
  countryName: "Bahamas",
  countryCode: "+1242",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/bs_bc1577c877.svg",
  isSelected: false
}, {
  id: 18,
  countryName: "Bahrain",
  countryCode: "+973",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/bh_8c2b019d76.svg",
  isSelected: false
}, {
  id: 19,
  countryName: "Bangladesh",
  countryCode: "+880",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/bd_80b416760b.svg",
  isSelected: false
}, {
  id: 20,
  countryName: "Barbados",
  countryCode: "+1246",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/bb_a02354692c.svg",
  isSelected: false
}, {
  id: 21,
  countryName: "Belarus",
  countryCode: "+375",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/by_918d226010.svg",
  isSelected: false
}, {
  id: 22,
  countryName: "Belgium",
  countryCode: "+32",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/be_94a5e50a91.svg",
  isSelected: false
}, {
  id: 23,
  countryName: "Belize",
  countryCode: "+501",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/bz_0e195f14bd.svg",
  isSelected: false
}, {
  id: 24,
  countryName: "Benin",
  countryCode: "+229",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/bj_e6e008dfd4.svg",
  isSelected: false
}, {
  id: 25,
  countryName: "Bermuda",
  countryCode: "+1441",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/bm_458200c646.svg",
  isSelected: false
}, {
  id: 26,
  countryName: "Bhutan",
  countryCode: "+975",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/bt_ba21028115.svg",
  isSelected: false
}, {
  id: 27,
  countryName: "Bolivia, Plurinational State of",
  countryCode: "+591",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/bo_0e60075fbc.svg",
  isSelected: false
}, {
  id: 28,
  countryName: "Bosnia and Herzegovina",
  countryCode: "+387",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ba_e1998bdb13.svg",
  isSelected: false
}, {
  id: 29,
  countryName: "Botswana",
  countryCode: "+267",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/bw_7272b3d014.svg",
  isSelected: false
}, {
  id: 30,
  countryName: "Brazil",
  countryCode: "+55",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/br_1fe146de4e.svg",
  isSelected: false
}, {
  id: 31,
  countryName: "British Indian Ocean Territory",
  countryCode: "+246",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/io_c624bb6f61.svg",
  isSelected: false
}, {
  id: 32,
  countryName: "Brunei Darussalam",
  countryCode: "+673",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/bn_92143678e9.svg",
  isSelected: false
}, {
  id: 33,
  countryName: "Bulgaria",
  countryCode: "+359",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/bg_79ac5b390d.svg",
  isSelected: false
}, {
  id: 34,
  countryName: "Burkina Faso",
  countryCode: "+226",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/bf_4acadb2297.svg",
  isSelected: false
}, {
  id: 35,
  countryName: "Burundi",
  countryCode: "+257",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/bi_d8b29d3aa1.svg",
  isSelected: false
}, {
  id: 36,
  countryName: "Cambodia",
  countryCode: "+855",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/kh_22d6e77ab8.svg",
  isSelected: false
}, {
  id: 37,
  countryName: "Cameroon",
  countryCode: "+237",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/cm_a3907a170a.svg",
  isSelected: false
}, {
  id: 38,
  countryName: "Canada",
  countryCode: "+1",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ca_7c2a04bb45.svg",
  isSelected: false
}, {
  id: 39,
  countryName: "Cape Verde",
  countryCode: "+238",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/cv_13ae8f4d67.svg",
  isSelected: false
}, {
  id: 40,
  countryName: "Cayman Islands",
  countryCode: "+ 345",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ky_284d914a38.svg",
  isSelected: false
}, {
  id: 41,
  countryName: "Central African Republic",
  countryCode: "+236",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/cf_fecb8f9c8b.svg",
  isSelected: false
}, {
  id: 42,
  countryName: "Chad",
  countryCode: "+235",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/td_8fc1d12782.svg",
  isSelected: false
}, {
  id: 43,
  countryName: "Chile",
  countryCode: "+56",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/cl_e9e9a97ad9.svg",
  isSelected: false
}, {
  id: 44,
  countryName: "China",
  countryCode: "+86",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/cn_33b59784bb.svg",
  isSelected: false
}, {
  id: 45,
  countryName: "Christmas Island",
  countryCode: "+61",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/cx_344ee795ff.svg",
  isSelected: false
}, {
  id: 46,
  countryName: "Cocos (Keeling) Islands",
  countryCode: "+61",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/cc_731c7e23b7.svg",
  isSelected: false
}, {
  id: 47,
  countryName: "Colombia",
  countryCode: "+57",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/co_152ac395e7.svg",
  isSelected: false
}, {
  id: 48,
  countryName: "Comoros",
  countryCode: "+269",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/km_ccccd27093.svg",
  isSelected: false
}, {
  id: 49,
  countryName: "Congo",
  countryCode: "+242",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/cg_c853f729b6.svg",
  isSelected: false
}, {
  id: 50,
  countryName: "Congo, The Democratic Republic of the Congo",
  countryCode: "+243",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/cd_7b8e417a4f.svg",
  isSelected: false
}, {
  id: 51,
  countryName: "Cook Islands",
  countryCode: "+682",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ck_fc224db93c.svg",
  isSelected: false
}, {
  id: 52,
  countryName: "Costa Rica",
  countryCode: "+506",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/cr_57627495fc.svg",
  isSelected: false
}, {
  id: 53,
  countryName: "Cote d'Ivoire",
  countryCode: "+225",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ci_8ee96372c9.svg",
  isSelected: false
}, {
  id: 54,
  countryName: "Croatia",
  countryCode: "+385",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/hr_bda4a07bfc.svg",
  isSelected: false
}, {
  id: 55,
  countryName: "Cuba",
  countryCode: "+53",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/cu_e332c87a81.svg",
  isSelected: false
}, {
  id: 56,
  countryName: "Cyprus",
  countryCode: "+357",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/cy_afb08885c9.svg",
  isSelected: false
}, {
  id: 57,
  countryName: "Czech Republic",
  countryCode: "+420",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/cz_7035ec1bd9.svg",
  isSelected: false
}, {
  id: 58,
  countryName: "Denmark",
  countryCode: "+45",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/dk_487217c50c.svg",
  isSelected: false
}, {
  id: 59,
  countryName: "Djibouti",
  countryCode: "+253",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/dj_676213b03b.svg",
  isSelected: false
}, {
  id: 60,
  countryName: "Dominica",
  countryCode: "+1767",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/dm_fe586a0f63.svg",
  isSelected: false
}, {
  id: 61,
  countryName: "Dominican Republic",
  countryCode: "+1849",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/do_46e1422e61.svg",
  isSelected: false
}, {
  id: 62,
  countryName: "Ecuador",
  countryCode: "+593",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ec_67f5dbde8d.svg",
  isSelected: false
}, {
  id: 63,
  countryName: "Egypt",
  countryCode: "+20",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/eg_6d5ac443d6.svg",
  isSelected: false
}, {
  id: 64,
  countryName: "El Salvador",
  countryCode: "+503",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/sv_9e0c3ca21d.svg",
  isSelected: false
}, {
  id: 65,
  countryName: "Equatorial Guinea",
  countryCode: "+240",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/gq_08155b266d.svg",
  isSelected: false
}, {
  id: 66,
  countryName: "Eritrea",
  countryCode: "+291",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/er_dc80e9841d.svg",
  isSelected: false
}, {
  id: 67,
  countryName: "Estonia",
  countryCode: "+372",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ee_1826a08425.svg",
  isSelected: false
}, {
  id: 68,
  countryName: "Ethiopia",
  countryCode: "+251",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/et_dbab9acf6b.svg",
  isSelected: false
}, {
  id: 69,
  countryName: "Falkland Islands (Malvinas)",
  countryCode: "+500",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/fk_12d2044901.svg",
  isSelected: false
}, {
  id: 70,
  countryName: "Faroe Islands",
  countryCode: "+298",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/fo_f61d135882.svg",
  isSelected: false
}, {
  id: 71,
  countryName: "Fiji",
  countryCode: "+679",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/fj_08aaf54283.svg",
  isSelected: false
}, {
  id: 72,
  countryName: "Finland",
  countryCode: "+358",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/fi_9b37346e32.svg",
  isSelected: false
}, {
  id: 73,
  countryName: "France",
  countryCode: "+33",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/fr_0663283b13.svg",
  isSelected: false
}, {
  id: 74,
  countryName: "French Guiana",
  countryCode: "+594",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/gf_3e60518c3d.svg",
  isSelected: false
}, {
  id: 75,
  countryName: "French Polynesia",
  countryCode: "+689",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/pf_33544370be.svg",
  isSelected: false
}, {
  id: 76,
  countryName: "Gabon",
  countryCode: "+241",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ga_530720306d.svg",
  isSelected: false
}, {
  id: 77,
  countryName: "Gambia",
  countryCode: "+220",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/gm_ea3eab33b2.svg",
  isSelected: false
}, {
  id: 78,
  countryName: "Georgia",
  countryCode: "+995",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ge_7b4c229160.svg",
  isSelected: false
}, {
  id: 79,
  countryName: "Germany",
  countryCode: "+49",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/de_5fb2a7c256.svg",
  isSelected: false
}, {
  id: 80,
  countryName: "Ghana",
  countryCode: "+233",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/gh_40ee8faf3c.svg",
  isSelected: false
}, {
  id: 81,
  countryName: "Gibraltar",
  countryCode: "+350",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/gi_05aa9d68dc.svg",
  isSelected: false
}, {
  id: 82,
  countryName: "Greece",
  countryCode: "+30",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/gr_dfe4ee6fc9.svg",
  isSelected: false
}, {
  id: 83,
  countryName: "Greenland",
  countryCode: "+299",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/gl_026cda8383.svg",
  isSelected: false
}, {
  id: 84,
  countryName: "Grenada",
  countryCode: "+1473",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/gd_d1d3c1c6b9.svg",
  isSelected: false
}, {
  id: 85,
  countryName: "Guadeloupe",
  countryCode: "+590",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/gp_60d79be444.svg",
  isSelected: false
}, {
  id: 86,
  countryName: "Guam",
  countryCode: "+1671",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/gu_628a9b336f.svg",
  isSelected: false
}, {
  id: 87,
  countryName: "Guatemala",
  countryCode: "+502",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/gt_18d9ec63d3.svg",
  isSelected: false
}, {
  id: 88,
  countryName: "Guernsey",
  countryCode: "+44",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/gg_358f910197.svg",
  isSelected: false
}, {
  id: 89,
  countryName: "Guinea",
  countryCode: "+224",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/gn_7c0f219f21.svg",
  isSelected: false
}, {
  id: 90,
  countryName: "Guinea-Bissau",
  countryCode: "+245",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/gw_bb218e6b17.svg",
  isSelected: false
}, {
  id: 91,
  countryName: "Guyana",
  countryCode: "+595",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/gy_e71eefe6a6.svg",
  isSelected: false
}, {
  id: 92,
  countryName: "Haiti",
  countryCode: "+509",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ht_db13a25aa3.svg",
  isSelected: false
}, {
  id: 93,
  countryName: "Holy See (Vatican City State)",
  countryCode: "+379",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/va_7dfceb4751.svg",
  isSelected: false
}, {
  id: 94,
  countryName: "Honduras",
  countryCode: "+504",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/hn_9c31f7da0b.svg",
  isSelected: false
}, {
  id: 95,
  countryName: "Hong Kong",
  countryCode: "+852",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/hk_4195f6a637.svg",
  isSelected: false
}, {
  id: 96,
  countryName: "Hungary",
  countryCode: "+36",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/hu_0dc1f03d76.svg",
  isSelected: false
}, {
  id: 97,
  countryName: "Iceland",
  countryCode: "+354",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/is_982f90ac4c.svg",
  isSelected: false
}, {
  id: 98,
  countryName: "India",
  countryCode: "+91",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/in_2f348ca223.svg",
  isSelected: false
}, {
  id: 99,
  countryName: "Indonesia",
  countryCode: "+62",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/id_2de6fc17db.svg",
  isSelected: false
}, {
  id: 100,
  countryName: "Iran, Islamic Republic of Persian Gulf",
  countryCode: "+98",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ir_f2d77d064a.svg",
  isSelected: false
}, {
  id: 101,
  countryName: "Iraq",
  countryCode: "+964",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/iq_75dffc9293.svg",
  isSelected: false
}, {
  id: 102,
  countryName: "Ireland",
  countryCode: "+353",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ie_df16b1d6b1.svg",
  isSelected: false
}, {
  id: 103,
  countryName: "Isle of Man",
  countryCode: "+44",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/im_9b579950d5.svg",
  isSelected: false
}, {
  id: 104,
  countryName: "Israel",
  countryCode: "+972",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/il_6f3aab6780.svg",
  isSelected: false
}, {
  id: 105,
  countryName: "Italy",
  countryCode: "+39",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/it_9dec37662a.svg",
  isSelected: false
}, {
  id: 106,
  countryName: "Jamaica",
  countryCode: "+1876",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/jm_47f97932d4.svg",
  isSelected: false
}, {
  id: 107,
  countryName: "Japan",
  countryCode: "+81",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/jp_0ca60607df.svg",
  isSelected: false
}, {
  id: 108,
  countryName: "Jersey",
  countryCode: "+44",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/je_65fd297923.svg",
  isSelected: false
}, {
  id: 109,
  countryName: "Jordan",
  countryCode: "+962",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/jo_ab7eab6a9b.svg",
  isSelected: false
}, {
  id: 110,
  countryName: "Kazakhstan",
  countryCode: "+77",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/kz_7ca26a1797.svg",
  isSelected: false
}, {
  id: 111,
  countryName: "Kenya",
  countryCode: "+254",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ke_fe19dcfb3f.svg",
  isSelected: false
}, {
  id: 112,
  countryName: "Kiribati",
  countryCode: "+686",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ki_72b5dad29f.svg",
  isSelected: false
}, {
  id: 113,
  countryName: "Korea, Democratic People's Republic of Korea",
  countryCode: "+850",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/kp_56eb4d2b2f.svg",
  isSelected: false
}, {
  id: 114,
  countryName: "Korea, Republic of South Korea",
  countryCode: "+82",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/kr_629c402040.svg",
  isSelected: false
}, {
  id: 115,
  countryName: "Kuwait",
  countryCode: "+965",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/kw_d618a241d6.svg",
  isSelected: false
}, {
  id: 116,
  countryName: "Kyrgyzstan",
  countryCode: "+996",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/kg_63f5ce41ff.svg",
  isSelected: false
}, {
  id: 117,
  countryName: "Laos",
  countryCode: "+856",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/la_94932d558c.svg",
  isSelected: false
}, {
  id: 118,
  countryName: "Latvia",
  countryCode: "+371",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/lv_72f2ef9654.svg",
  isSelected: false
}, {
  id: 119,
  countryName: "Lebanon",
  countryCode: "+961",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/lb_5b989a3874.svg",
  isSelected: false
}, {
  id: 120,
  countryName: "Lesotho",
  countryCode: "+266",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ls_20424a3147.svg",
  isSelected: false
}, {
  id: 121,
  countryName: "Liberia",
  countryCode: "+231",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/lr_1b7facc87c.svg",
  isSelected: false
}, {
  id: 122,
  countryName: "Libyan Arab Jamahiriya",
  countryCode: "+218",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ly_c73dbbe19a.svg",
  isSelected: false
}, {
  id: 123,
  countryName: "Liechtenstein",
  countryCode: "+423",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/li_6cfab8e596.svg",
  isSelected: false
}, {
  id: 124,
  countryName: "Lithuania",
  countryCode: "+370",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/lt_760e0db821.svg",
  isSelected: false
}, {
  id: 125,
  countryName: "Luxembourg",
  countryCode: "+352",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/lu_3430d312e6.svg",
  isSelected: false
}, {
  id: 126,
  countryName: "Macao",
  countryCode: "+853",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/mo_ce442c9a20.svg",
  isSelected: false
}, {
  id: 127,
  countryName: "Macedonia",
  countryCode: "+389",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/mk_3b0db18547.svg",
  isSelected: false
}, {
  id: 128,
  countryName: "Madagascar",
  countryCode: "+261",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/mg_25b9f79094.svg",
  isSelected: false
}, {
  id: 129,
  countryName: "Malawi",
  countryCode: "+265",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/mw_1d5c9a75a5.svg",
  isSelected: false
}, {
  id: 130,
  countryName: "Malaysia",
  countryCode: "+60",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/my_01642481af.svg",
  isSelected: false
}, {
  id: 131,
  countryName: "Maldives",
  countryCode: "+960",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/mv_d37ac91ee5.svg",
  isSelected: false
}, {
  id: 132,
  countryName: "Mali",
  countryCode: "+223",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ml_102d51da19.svg",
  isSelected: false
}, {
  id: 133,
  countryName: "Malta",
  countryCode: "+356",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/mt_1b7ef26bca.svg",
  isSelected: false
}, {
  id: 134,
  countryName: "Marshall Islands",
  countryCode: "+692",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/mh_b697ee26c9.svg",
  isSelected: false
}, {
  id: 135,
  countryName: "Martinique",
  countryCode: "+596",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/mq_db3457b144.svg",
  isSelected: false
}, {
  id: 136,
  countryName: "Mauritania",
  countryCode: "+222",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/mr_bc2eaad7b5.svg",
  isSelected: false
}, {
  id: 137,
  countryName: "Mauritius",
  countryCode: "+230",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/mu_522c39a86d.svg",
  isSelected: false
}, {
  id: 138,
  countryName: "Mayotte",
  countryCode: "+262",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/yt_ff3676b3df.svg",
  isSelected: false
}, {
  id: 139,
  countryName: "Mexico",
  countryCode: "+52",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/mx_efd4edb50f.svg",
  isSelected: false
}, {
  id: 140,
  countryName: "Micronesia, Federated States of Micronesia",
  countryCode: "+691",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/fm_1ec8cafdf5.svg",
  isSelected: false
}, {
  id: 141,
  countryName: "Moldova",
  countryCode: "+373",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/md_43399ff3b7.svg",
  isSelected: false
}, {
  id: 142,
  countryName: "Monaco",
  countryCode: "+377",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/mc_947ce3c758.svg",
  isSelected: false
}, {
  id: 143,
  countryName: "Mongolia",
  countryCode: "+976",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/mn_76b62fbb32.svg",
  isSelected: false
}, {
  id: 144,
  countryName: "Montenegro",
  countryCode: "+382",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/me_b706d7ae7a.svg",
  isSelected: false
}, {
  id: 145,
  countryName: "Montserrat",
  countryCode: "+1664",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ms_9010c2d84e.svg",
  isSelected: false
}, {
  id: 146,
  countryName: "Morocco",
  countryCode: "+212",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ma_f4e0c85e21.svg",
  isSelected: false
}, {
  id: 147,
  countryName: "Mozambique",
  countryCode: "+258",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/mz_1c967de0df.svg",
  isSelected: false
}, {
  id: 148,
  countryName: "Myanmar",
  countryCode: "+95",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/mm_dabd0c76c1.svg",
  isSelected: false
}, {
  id: 149,
  countryName: "Namibia",
  countryCode: "+264",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/na_f6a916f1a0.svg",
  isSelected: false
}, {
  id: 150,
  countryName: "Nauru",
  countryCode: "+674",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/nr_cedbc24937.svg",
  isSelected: false
}, {
  id: 151,
  countryName: "Nepal",
  countryCode: "+977",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/np_68159406f1.svg",
  isSelected: false
}, {
  id: 152,
  countryName: "Netherlands",
  countryCode: "+31",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/nl_94d823f692.svg",
  isSelected: false
}, {
  id: 153,
  countryName: "Netherlands Antilles",
  countryCode: "+599",
  countryFlag: "",
  isSelected: false
}, {
  id: 154,
  countryName: "New Caledonia",
  countryCode: "+687",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/nc_bd4f7782e4.svg",
  isSelected: false
}, {
  id: 155,
  countryName: "New Zealand",
  countryCode: "+64",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/nz_3b7d223d93.svg",
  isSelected: false
}, {
  id: 156,
  countryName: "Nicaragua",
  countryCode: "+505",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ni_36da7af5f5.svg",
  isSelected: false
}, {
  id: 157,
  countryName: "Niger",
  countryCode: "+227",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ne_03e4003d07.svg",
  isSelected: false
}, {
  id: 158,
  countryName: "Nigeria",
  countryCode: "+234",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ng_f7ba0fee41.svg",
  isSelected: false
}, {
  id: 159,
  countryName: "Niue",
  countryCode: "+683",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/nu_1158e9e356.svg",
  isSelected: false
}, {
  id: 160,
  countryName: "Norfolk Island",
  countryCode: "+672",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/nf_751a7607f2.svg",
  isSelected: false
}, {
  id: 161,
  countryName: "Northern Mariana Islands",
  countryCode: "+1670",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/mp_76f9cc05ed.svg",
  isSelected: false
}, {
  id: 162,
  countryName: "Norway",
  countryCode: "+47",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/no_09622db0f8.svg",
  isSelected: false
}, {
  id: 163,
  countryName: "Oman",
  countryCode: "+968",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/om_40d63e31e0.svg",
  isSelected: false
}, {
  id: 164,
  countryName: "Pakistan",
  countryCode: "+92",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/pk_243f9b996c.svg",
  isSelected: false
}, {
  id: 165,
  countryName: "Palau",
  countryCode: "+680",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/pw_687f71d510.svg",
  isSelected: false
}, {
  id: 166,
  countryName: "Palestinian Territory, Occupied",
  countryCode: "+970",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ps_a21a219fd7.svg",
  isSelected: false
}, {
  id: 167,
  countryName: "Panama",
  countryCode: "+507",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/pa_d03161a3fb.svg",
  isSelected: false
}, {
  id: 168,
  countryName: "Papua New Guinea",
  countryCode: "+675",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/pg_15c9c0849b.svg",
  isSelected: false
}, {
  id: 169,
  countryName: "Paraguay",
  countryCode: "+595",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/py_aa5374ee0c.svg",
  isSelected: false
}, {
  id: 170,
  countryName: "Peru",
  countryCode: "+51",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/pe_304060789b.svg",
  isSelected: false
}, {
  id: 171,
  countryName: "Philippines",
  countryCode: "+63",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ph_0c6517658e.svg",
  isSelected: false
}, {
  id: 172,
  countryName: "Pitcairn",
  countryCode: "+872",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/pn_8cda9520f4.svg",
  isSelected: false
}, {
  id: 173,
  countryName: "Poland",
  countryCode: "+48",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/pl_59003a0441.svg",
  isSelected: false
}, {
  id: 174,
  countryName: "Portugal",
  countryCode: "+351",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/pt_4f355c972d.svg",
  isSelected: false
}, {
  id: 175,
  countryName: "Puerto Rico",
  countryCode: "+1939",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/pr_b5898f74e9.svg",
  isSelected: false
}, {
  id: 176,
  countryName: "Qatar",
  countryCode: "+974",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/qa_f4b77b4796.svg",
  isSelected: false
}, {
  id: 177,
  countryName: "Romania",
  countryCode: "+40",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ro_96930c11c6.svg",
  isSelected: false
}, {
  id: 178,
  countryName: "Russia",
  countryCode: "+7",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ru_cb98a2e7cd.svg",
  isSelected: false
}, {
  id: 179,
  countryName: "Rwanda",
  countryCode: "+250",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/rw_4d811df706.svg",
  isSelected: false
}, {
  id: 180,
  countryName: "Reunion",
  countryCode: "+262",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/re_c545f18901.svg",
  isSelected: false
}, {
  id: 181,
  countryName: "Saint Barthelemy",
  countryCode: "+590",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/bl_aba350a1ac.svg",
  isSelected: false
}, {
  id: 182,
  countryName: "Saint Helena, Ascension and Tristan Da Cunha",
  countryCode: "+290",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/sh_c40f34d68a.svg",
  isSelected: false
}, {
  id: 183,
  countryName: "Saint Kitts and Nevis",
  countryCode: "+1869",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/kn_add6ab96ee.svg",
  isSelected: false
}, {
  id: 184,
  countryName: "Saint Lucia",
  countryCode: "+1758",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/lc_f17ac78364.svg",
  isSelected: false
}, {
  id: 185,
  countryName: "Saint Martin",
  countryCode: "+590",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/mf_93af7cb897.svg",
  isSelected: false
}, {
  id: 186,
  countryName: "Saint Pierre and Miquelon",
  countryCode: "+508",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/pm_d818181846.svg",
  isSelected: false
}, {
  id: 187,
  countryName: "Saint Vincent and the Grenadines",
  countryCode: "+1784",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/vc_55285c563d.svg",
  isSelected: false
}, {
  id: 188,
  countryName: "Samoa",
  countryCode: "+685",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ws_9c343ef1f6.svg",
  isSelected: false
}, {
  id: 189,
  countryName: "San Marino",
  countryCode: "+378",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/sm_cd9411d1fe.svg",
  isSelected: false
}, {
  id: 190,
  countryName: "Sao Tome and Principe",
  countryCode: "+239",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/st_ce4addf4f5.svg",
  isSelected: false
}, {
  id: 191,
  countryName: "Saudi Arabia",
  countryCode: "+966",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/sa_86c1673d4c.svg",
  isSelected: false
}, {
  id: 192,
  countryName: "Senegal",
  countryCode: "+221",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/sn_0112ea7aad.svg",
  isSelected: false
}, {
  id: 193,
  countryName: "Serbia",
  countryCode: "+381",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/rs_abb13a0976.svg",
  isSelected: false
}, {
  id: 194,
  countryName: "Seychelles",
  countryCode: "+248",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/sc_dfe921906f.svg",
  isSelected: false
}, {
  id: 195,
  countryName: "Sierra Leone",
  countryCode: "+232",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/sl_9cf3f36dde.svg",
  isSelected: false
}, {
  id: 196,
  countryName: "Singapore",
  countryCode: "+65",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/sg_d7e5f5c7a1.svg",
  isSelected: false
}, {
  id: 197,
  countryName: "Slovakia",
  countryCode: "+421",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/sk_4b012c3a02.svg",
  isSelected: false
}, {
  id: 198,
  countryName: "Slovenia",
  countryCode: "+386",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/si_4738fb6e13.svg",
  isSelected: false
}, {
  id: 199,
  countryName: "Solomon Islands",
  countryCode: "+677",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/sb_aac5b7df9e.svg",
  isSelected: false
}, {
  id: 200,
  countryName: "Somalia",
  countryCode: "+252",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/so_f921cd173e.svg",
  isSelected: false
}, {
  id: 201,
  countryName: "South Africa",
  countryCode: "+27",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/za_f6bc68a503.svg",
  isSelected: false
}, {
  id: 202,
  countryName: "South Sudan",
  countryCode: "+211",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ss_5a3947cdd6.svg",
  isSelected: false
}, {
  id: 203,
  countryName: "South Georgia and the South Sandwich Islands",
  countryCode: "+500",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/gs_b7d9082616.svg",
  isSelected: false
}, {
  id: 204,
  countryName: "Spain",
  countryCode: "+34",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/es_0db5cb4322.svg",
  isSelected: false
}, {
  id: 205,
  countryName: "Sri Lanka",
  countryCode: "+94",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/lk_bd4f014503.svg",
  isSelected: false
}, {
  id: 206,
  countryName: "Sudan",
  countryCode: "+249",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/sd_273748b57d.svg",
  isSelected: false
}, {
  id: 207,
  countryName: "Suriname",
  countryCode: "+597",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/sr_9321eba2cd.svg",
  isSelected: false
}, {
  id: 208,
  countryName: "Svalbard and Jan Mayen",
  countryCode: "+47",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/sj_a8dea40936.svg",
  isSelected: false
}, {
  id: 209,
  countryName: "Swaziland",
  countryCode: "+268",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/sz_bacdda09b8.svg",
  isSelected: false
}, {
  id: 210,
  countryName: "Sweden",
  countryCode: "+46",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/se_e95610f345.svg",
  isSelected: false
}, {
  id: 211,
  countryName: "Switzerland",
  countryCode: "+41",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ch_459b3eed4c.svg",
  isSelected: false
}, {
  id: 212,
  countryName: "Syrian Arab Republic",
  countryCode: "+963",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/sy_ade744b21f.svg",
  isSelected: false
}, {
  id: 213,
  countryName: "Taiwan",
  countryCode: "+886",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/tw_fbef2f7e67.svg",
  isSelected: false
}, {
  id: 214,
  countryName: "Tajikistan",
  countryCode: "+992",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/tj_81b475f0fe.svg",
  isSelected: false
}, {
  id: 215,
  countryName: "Tanzania, United Republic of Tanzania",
  countryCode: "+255",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/tz_f1d5f7d3e9.svg",
  isSelected: false
}, {
  id: 216,
  countryName: "Thailand",
  countryCode: "+66",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/th_5a7eaa3694.svg",
  isSelected: false
}, {
  id: 217,
  countryName: "Timor-Leste",
  countryCode: "+670",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/tl_3e2fb59693.svg",
  isSelected: false
}, {
  id: 218,
  countryName: "Togo",
  countryCode: "+228",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/tg_9f8762516f.svg",
  isSelected: false
}, {
  id: 219,
  countryName: "Tokelau",
  countryCode: "+690",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/tk_1886606d8e.svg",
  isSelected: false
}, {
  id: 220,
  countryName: "Tonga",
  countryCode: "+676",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/to_3b57ec3d01.svg",
  isSelected: false
}, {
  id: 221,
  countryName: "Trinidad and Tobago",
  countryCode: "+1868",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/tt_aca657a286.svg",
  isSelected: false
}, {
  id: 222,
  countryName: "Tunisia",
  countryCode: "+216",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/tn_419dee44b6.svg",
  isSelected: false
}, {
  id: 223,
  countryName: "Turkey",
  countryCode: "+90",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/tr_8688d44b48.svg",
  isSelected: false
}, {
  id: 224,
  countryName: "Turkmenistan",
  countryCode: "+993",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/tm_995d608c9b.svg",
  isSelected: false
}, {
  id: 225,
  countryName: "Turks and Caicos Islands",
  countryCode: "+1649",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/tc_96943da753.svg",
  isSelected: false
}, {
  id: 226,
  countryName: "Tuvalu",
  countryCode: "+688",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/tv_84f64355d7.svg",
  isSelected: false
}, {
  id: 227,
  countryName: "Uganda",
  countryCode: "+256",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ug_f230242c97.svg",
  isSelected: false
}, {
  id: 228,
  countryName: "Ukraine",
  countryCode: "+380",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ua_9bf9143175.svg",
  isSelected: false
}, {
  id: 229,
  countryName: "United Arab Emirates",
  countryCode: "+971",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ae_f00b2b3821.svg",
  isSelected: false
}, {
  id: 230,
  countryName: "United Kingdom",
  countryCode: "+44",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/gb_c8e421182a.svg",
  isSelected: false
}, {
  id: 231,
  countryName: "United States",
  countryCode: "+1",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/us_54f9a75482.svg",
  isSelected: false
}, {
  id: 232,
  countryName: "Uruguay",
  countryCode: "+598",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/uy_599b5709fb.svg",
  isSelected: false
}, {
  id: 233,
  countryName: "Uzbekistan",
  countryCode: "+998",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/uz_12f12ac802.svg",
  isSelected: false
}, {
  id: 234,
  countryName: "Vanuatu",
  countryCode: "+678",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/vu_b1e2ff57ed.svg",
  isSelected: false
}, {
  id: 235,
  countryName: "Venezuela, Bolivarian Republic of Venezuela",
  countryCode: "+58",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ve_86c2cba559.svg",
  isSelected: false
}, {
  id: 236,
  countryName: "Vietnam",
  countryCode: "+84",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/vn_0ec5fe6681.svg",
  isSelected: false
}, {
  id: 237,
  countryName: "Virgin Islands, British",
  countryCode: "+1284",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/vg_500ed1aeb1.svg",
  isSelected: false
}, {
  id: 238,
  countryName: "Virgin Islands, U.S.",
  countryCode: "+1340",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/vi_d5f6b6fefc.svg",
  isSelected: false
}, {
  id: 239,
  countryName: "Wallis and Futuna",
  countryCode: "+681",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/wf_a9041c6cb9.svg",
  isSelected: false
}, {
  id: 240,
  countryName: "Yemen",
  countryCode: "+967",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/ye_20d7839f98.svg",
  isSelected: false
}, {
  id: 241,
  countryName: "Zambia",
  countryCode: "+260",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/zm_8c322e0acb.svg",
  isSelected: false
}, {
  id: 242,
  countryName: "Zimbabwe",
  countryCode: "+263",
  countryFlag: "https://tripmoneycmsimgak.mmtcdn.com/img/zw_eb8cbe08b8.svg",
  isSelected: false
}];
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/InsuranceTravellerDetail/InsuranceTravellerDetail/InsuranceTravellerDetail.tsx


function InsuranceTravellerDetail_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function InsuranceTravellerDetail_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? InsuranceTravellerDetail_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : InsuranceTravellerDetail_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





 // import "pwa-mmt-ui-header/ssr/header.css";








const InsuranceTravellerDetail_analytics = (0,insurance/* getAnalytics */.I)();

const InsuranceTravellerDetail = ({
  travellerDetailData,
  setActiveModal,
  isLoading,
  checkoutError,
  handleTravellerPayment,
  onFormDataChange,
  getSelectedCountry,
  firstErrorIndex,
  setFirstErrorIndex,
  onSetError
}) => {
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const {
    type
  } = (0,ui_src/* usePlanType */.U)();
  const {
    title,
    travellerPlanInfo,
    planInfo,
    travellerDetail,
    tnc,
    previewBenefits,
    planBenefits,
    travelInfo,
    widgets,
    vendorDisplayIcon,
    isDomesticBooking,
    chatBotInfo
  } = travellerDetailData || {};
  const travellerDataFromStore = (0,utils/* getTravDetailsFromMemory */.fP)();
  const {
    countryCode
  } = travellerDataFromStore || {};
  const {
    persuasionBanner
  } = widgets || {};
  const {
    0: travelDetails,
    1: setTravelDetails
  } = (0,react.useState)(null);
  const {
    0: showBenefits,
    1: setShowBenefits
  } = (0,react.useState)(false);
  const {
    0: showPaymentFailModal,
    1: setShowPaymentFailModal
  } = (0,react.useState)(false);
  const {
    0: showCodeModal,
    1: setCodeModal
  } = (0,react.useState)(false);
  const {
    0: countryData,
    1: setCountryData
  } = (0,react.useState)(COUNTRY_DATA);
  const {
    0: addOnProductDetails,
    1: setAddOnProductDetails
  } = (0,react.useState)();
  const {
    countries,
    startDate,
    endDate,
    travellers,
    purpose
  } = travelDetails || {};
  const experiment = (0,react.useContext)(ui_widgets_src/* ExperimentTrackingString */.Mq) || "";
  (0,react.useEffect)(() => {
    const queryParams = new URLSearchParams(window.location.search);
    InsuranceTravellerDetail_analytics?.trackPageLoadEvent({
      pageName: "REVIEW",
      experiment
    }, type);
    const selectedCountries = (0,XDMAnalytics.getSelectedCountriesFromLocalStorage)(queryParams.get("countries")?.split(",") || []);
    const segment = queryParams.get("segment");
    const startDate = queryParams.get("startDate");
    const endDate = queryParams.get("endDate");
    const travellers = queryParams.get("travellers");
    const subpageName = queryParams.get("type");
    const productId = queryParams.get("productId");
    let start, end;

    if (startDate && endDate) {
      start = (0,utils/* convertUnixToDate */.P9)(Number(startDate));
      end = (0,utils/* convertUnixToDate */.P9)(Number(endDate));
    }

    (0,XDMAnalytics.initializePageTracking)({
      page_context: InsuranceTravellerDetail_objectSpread({
        page_name: "review",
        page_type: "funnel",
        funnel_step: "review"
      }, subpageName && {
        subpage_name: subpageName
      }),
      event_detail: InsuranceTravellerDetail_objectSpread({}, productId && {
        components: {
          product_list: [{
            id: productId ?? ""
          }]
        }
      })
    }, {
      countries: selectedCountries,
      journeyType: segment || "",
      travellers: travellers ? parseInt(travellers) : 1,
      fromDateTime: start ? start.getTime() / 1000 : 0,
      toDateTime: end ? end.getTime() / 1000 : 0,
      isStoreSearchContext: true
    });
  }, []);
  (0,react.useEffect)(() => {
    let queryParams = new URLSearchParams(window.location.search);
    const countries = travellerDetailData.travelDetails && travellerDetailData.travelDetails.countries;
    const startDate = queryParams.get("startDate");
    const endDate = queryParams.get("endDate");
    const travellers = queryParams.get("travellers");
    const purpose = queryParams.get("purpose");
    const paymentSuccess = queryParams.get("paymentSuccess");
    setTravelDetails({
      countries,
      startDate,
      endDate,
      travellers,
      purpose
    });

    if (paymentSuccess === "false") {
      setShowPaymentFailModal(true);
    }
  }, []);
  (0,react.useEffect)(() => {
    const countries = countryData.map(country => InsuranceTravellerDetail_objectSpread(InsuranceTravellerDetail_objectSpread({}, country), {}, {
      isSelected: country.countryCode === (countryCode || "+91") ? true : false
    }));
    setCountryData(countries);
  }, []);

  const toggleCountryModal = () => setCodeModal(!showCodeModal);

  const handleCountryCodeModal = countries => {
    setCountryData(countries);
    toggleCountryModal();
    const selectedCountry = countries?.find(item => item.isSelected);
    (0,utils/* setTravDetailsInMemory */.Yp)(InsuranceTravellerDetail_objectSpread(InsuranceTravellerDetail_objectSpread({}, travellerDataFromStore), {}, {
      countryCode: selectedCountry?.countryCode
    }));
  };

  const handleViewBenefits = () => {
    setShowBenefits(!showBenefits);
  };

  const handleTncClick = () => {
    InsuranceTravellerDetail_analytics?.trackTravDetailsEvents({
      actionType: "TnC_clicked"
    }, "pageView", type);
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "TnC_clicked"
      }
    });
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(static_components.DesktopLayout, {
      pageName: "ADD_TRAVELLERS",
      chatbotBottomMargin: 100,
      height: isDomesticBooking ? "725px" : "620px",
      title: device === "lg" ? title : isDomesticBooking ? {} : title,
      chatBotInfo: chatBotInfo,
      leftComp: /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(static_components.FlexComp, {
          flexDirection: "column",
          gap: "16px",
          "data-test-id": "InsuranceTravellerDetail-FlexComp",
          children: [isDomesticBooking && device === "sm" && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.GreatChoice, {
            icon: persuasionBanner?.icon,
            title: persuasionBanner?.title,
            info: persuasionBanner?.description,
            background: "#4A4A4A",
            padding: "8px 12px 8px 12px",
            radius: "8px",
            "data-test-id": "InsuranceTravellerDetail-GreatChoice"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.ListingEditDetails, {
            mode: travelInfo?.mode,
            title: travelInfo?.countries ?? countries,
            travelDates: {
              startDate: (0,utils/* convertUnixToDate */.P9)(Number(travelInfo?.travelDates?.startDate ?? startDate)),
              endDate: (0,utils/* convertUnixToDate */.P9)(Number(travelInfo?.travelDates?.endDate ?? endDate))
            },
            travelPurpose: travelInfo?.travelPurpose ?? purpose,
            travellerCount: Number(travelInfo?.travellers || travellers),
            showEditIcon: false,
            "data-test-id": "InsuranceTravellerDetail-ListingEditDetails"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.ListingTravelDetails, {
            data: planInfo,
            previewBenefits: previewBenefits,
            tnc: tnc,
            handleTnc: handleTncClick,
            handleViewBenefits: handleViewBenefits,
            vendorDisplayIcon: vendorDisplayIcon,
            addOnProductDetails: addOnProductDetails,
            "data-test-id": "InsuranceTravellerDetail-ListingTravelDetails"
          })]
        }), device === "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.GreatChoice, {
          icon: persuasionBanner ? persuasionBanner?.icon : travellerPlanInfo?.icon,
          title: persuasionBanner ? persuasionBanner?.title : travellerPlanInfo?.title,
          info: persuasionBanner ? persuasionBanner?.description : travellerPlanInfo?.info,
          "data-test-id": "InsuranceTravellerDetail-GreatChoice"
        })]
      }),
      rightComp: /*#__PURE__*/(0,jsx_runtime.jsx)(react.Fragment, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.AddTravellerDetails, {
          data: travellerDetailData,
          title: travellerDetail?.title,
          info: travellerDetail?.info,
          countryData: countryData,
          handleCountryCodeModal: toggleCountryModal,
          benefitsData: getMoreBenefits(planBenefits),
          benefitsTitle: planBenefits?.heading,
          travellerCount: Number(travelInfo?.travellers || travellers),
          showBenefits: showBenefits,
          handleViewBenefits: handleViewBenefits,
          addOnProductDetails: addOnProductDetails,
          setAddOnProductDetails: setAddOnProductDetails,
          setActiveModal: setActiveModal,
          isLoading: isLoading,
          checkoutError: checkoutError,
          handleTravellerPayment: handleTravellerPayment,
          onFormDataChange: onFormDataChange,
          getSelectedCountry: getSelectedCountry,
          firstErrorIndex: firstErrorIndex,
          setFirstErrorIndex: setFirstErrorIndex,
          onSetError: onSetError,
          "data-test-id": "InsuranceTravellerDetail-AddTravellerDetails"
        })
      }),
      "data-test-id": "InsuranceTravellerDetail-DesktopLayout"
    }), showCodeModal && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.SelectCountryCodeModal, {
      countryData: countryData,
      handleSelectCountry: handleCountryCodeModal,
      handleClose: toggleCountryModal,
      "data-test-id": "InsuranceTravellerDetail-SelectCountryCodeModal"
    }), showPaymentFailModal && /*#__PURE__*/(0,jsx_runtime.jsx)(PaymentFailedModal/* default */.Z, {
      title: "Payment Failed",
      info: "Oops, your payment could not be processed!",
      noteTitle: "Note: ",
      noteInfo: "In case the amount has been deducted from your bank account, the same will be credited back within in 2-4 hours",
      retryBtnTxt: "RETRY PAYMENT",
      backBtnTxt: "GO BACK",
      "data-test-id": "InsuranceTravellerDetail-PaymentFailedModal"
    })]
  });
};

/* harmony default export */ const InsuranceTravellerDetail_InsuranceTravellerDetail = (InsuranceTravellerDetail);
// EXTERNAL MODULE: ../../libs/utility/src/lib/analytics/XDMAnalytics/xdmEvents.ts + 1 modules
var xdmEvents = __webpack_require__(46535);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/Toast/WebToast.tsx + 1 modules
var WebToast = __webpack_require__(78891);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/InsuranceTravellerDetail/InsuranceTravellerDetailV2/InsuranceTravelDetailsV2.styles.ts


const TravellerDetailLayoutV2 = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceTravelDetailsV2styles__TravellerDetailLayoutV2",
  componentId: "tr96d2-0"
})(["width:100%;padding:50px 0;background-image:linear-gradient(180deg,#282a47 0.38%,#554276 100%);background-size:100% 157px;background-color:#f4f4f4;background-repeat:no-repeat;padding-top:16px;position:relative;z-index:2;.userSection{img,picture{flex-shrink:1;}}height:100%;"]);
const InsuranceTravelDetailsV2_styles_HeadComp = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceTravelDetailsV2styles__HeadComp",
  componentId: "tr96d2-1"
})(["width:1192px;margin:0 auto 10px auto;"]);
const InsuranceTravelDetailsV2_styles_MainContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceTravelDetailsV2styles__MainContainer",
  componentId: "tr96d2-2"
})(["margin:0 auto;width:1200px;display:flex;justify-content:space-between;gap:12px;"]);
const InsuranceTravelDetailsV2_styles_LeftComp = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceTravelDetailsV2styles__LeftComp",
  componentId: "tr96d2-3"
})(["width:1027px;gap:12px;display:flex;flex-direction:column;"]);
const InsuranceTravelDetailsV2_styles_RightComp = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceTravelDetailsV2styles__RightComp",
  componentId: "tr96d2-4"
})(["width:440px;gap:12px;display:flex;flex-direction:column;"]);
const WebToastWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "InsuranceTravelDetailsV2styles__WebToastWrap",
  componentId: "tr96d2-5"
})(["div{height:40px;}@media ", "{position:fixed;bottom:108px;width:100%;& >{width:100%;}div{}}@media ", "{& > div{margin-left:30px;}div{width:502px;}position:sticky;bottom:120px;}"], src.deviceType.mobile, src.deviceType.desktop);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/InsuranceTravellerDetail/InsuranceTravellerDetailV2/InsuranceTravellerDetailV2.tsx


function InsuranceTravellerDetailV2_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function InsuranceTravellerDetailV2_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? InsuranceTravellerDetailV2_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : InsuranceTravellerDetailV2_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


















const InsTravDetailV2 = ({
  travellerDetailData: InsTravDetailV2,
  handleTravellerPayment,
  onFormDataChange,
  selectedCountry,
  getSelectedCountry,
  setActiveModal,
  isLoading: externalIsLoading,
  checkoutError,
  firstErrorIndex,
  setFirstErrorIndex,
  onSetError
}) => {
  const {
    0: secondaryContactFields,
    1: setSecondaryContactFields
  } = (0,react.useState)({});
  const {
    components,
    pageData
  } = InsTravDetailV2;
  const {
    travellerCount,
    errorToasts
  } = pageData || {};
  const {
    formErrorToast: pageFormErrorToast,
    addErrorToast: pageAddErrorToast
  } = errorToasts || {};
  const {
    formErrorToast,
    addErrorToast
  } = src.constants; // Analytics and plan type

  const analytics = (0,insurance/* getAnalytics */.I)();
  (0,react.useEffect)(() => {
    analytics?.trackPageLoadEvent({
      pageName: "REVIEW",
      experiment: pageData?.experiment
    });
    const queryParams = new URLSearchParams(window.location.search);
    const selectedCountries = (0,XDMAnalytics.getSelectedCountriesFromLocalStorage)(queryParams.get("countries")?.split(",") || []);
    const segment = queryParams.get("segment");
    const startDate = queryParams.get("startDate");
    const endDate = queryParams.get("endDate");
    let start, end;

    if (startDate && endDate) {
      start = (0,utils/* convertUnixToDate */.P9)(Number(startDate));
      end = (0,utils/* convertUnixToDate */.P9)(Number(endDate));
    }

    const travellers = queryParams.get("travellers");
    const subpageName = queryParams.get("type");
    const productId = queryParams.get("productId");
    (0,XDMAnalytics.initializePageTracking)({
      page_context: InsuranceTravellerDetailV2_objectSpread({
        page_name: "review",
        page_type: "funnel",
        funnel_step: "review"
      }, subpageName && {
        subpage_name: `${subpageName}_mypartner`
      }),
      event_detail: InsuranceTravellerDetailV2_objectSpread({}, productId && {
        components: {
          product_list: [{
            id: productId ?? ""
          }]
        }
      })
    }, {
      countries: selectedCountries,
      journeyType: segment || "",
      travellers: travellers ? parseInt(travellers) : 1,
      fromDateTime: start ? start.getTime() / 1000 : 0,
      toDateTime: end ? end.getTime() / 1000 : 0,
      isStoreSearchContext: true
    });
  }, []);
  const {
    type
  } = (0,ui_src/* usePlanType */.U)();
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)(); // Use external loading state if provided, otherwise use local state

  const {
    0: localIsLoading,
    1: setLocalIsLoading
  } = (0,react.useState)(false);
  const isLoading = externalIsLoading !== undefined ? externalIsLoading : localIsLoading; // Validation state

  const {
    0: isSelectedError,
    1: setIsSelectedError
  } = (0,react.useState)(false);
  const {
    0: isFieldError,
    1: setIsFieldError
  } = (0,react.useState)(false);
  const methods = (0,index_esm/* useForm */.cI)({
    defaultValues: {
      travellerData: Array.from({
        length: pageData?.travCount ?? 2 // TODO: get length of travCount and savedTravellers length

      }).map(() => ({
        name: "",
        dob: "",
        gender: "",
        passport: "",
        nomineeName: "",
        isSelected: false
      })),
      primaryContactData: {
        email: "",
        mobile: ""
      },
      tncs: Array.from({
        length: 1
      }).map(() => true) // TODO: get length of tncs

    },
    mode: "onTouched"
  });
  const {
    control,
    getValues,
    setValue,
    getFieldState,
    setError,
    handleSubmit,
    trigger
  } = methods;
  const formValues = getValues(); // Watch traveller data to track selected count

  const travellerData = (0,index_esm/* useWatch */.qo)({
    control,
    name: "travellerData"
  }); // Calculate selected count

  const selectedCount = (0,react.useMemo)(() => travellerData?.filter(traveller => traveller.isSelected)?.length ?? 0, [travellerData]); // References for scrolling to errors

  const travellerRef = (0,react.useRef)(null);
  const primaryContactRef = (0,react.useRef)(null);
  const tncRef = (0,react.useRef)(null); // State to control which traveller is expanded (for collapse/expand animation)

  const {
    0: expandedTravellerIndex,
    1: setExpandedTravellerIndex
  } = (0,react.useState)(-1); // Reusable method to scroll to error traveller

  const scrollToErrorTraveller = (errorIndex, delay = 300) => {
    setTimeout(() => {
      // Try to find the specific traveller element by data attribute
      const errorTravellerElement = document.querySelector(`[data-traveller-index="${errorIndex}"]`);

      if (errorTravellerElement) {
        errorTravellerElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest"
        });
      } else {
        // Fallback to travellerRef
        travellerRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest"
        });
      }
    }, delay);
  }; // Handle checkout errors - throw as ClientError like in AddTravellerDetails


  if (checkoutError && true) {
    throw new utility_src/* ClientError */.XF(checkoutError);
  } // Handle firstErrorIndex - collapse all travellers and focus on error traveller


  (0,react.useEffect)(() => {
    if (firstErrorIndex !== undefined && firstErrorIndex >= 0) {
      // Collapse all travellers (including the error one) to show error in collapsed format
      setExpandedTravellerIndex(-1); // Scroll to error traveller after collapse animation

      scrollToErrorTraveller(firstErrorIndex, 300);
    }

    if (setFirstErrorIndex) {
      setFirstErrorIndex(-1);
    }
  }, [firstErrorIndex, setFirstErrorIndex]); // Handle onSetError - set form errors when onSetError prop changes

  (0,react.useEffect)(() => {
    if (onSetError) {
      setError(onSetError?.errTrype, onSetError?.errName);
    }
  }, [onSetError, setError]);

  const handleErrorToast = () => {
    setTimeout(() => {
      setIsSelectedError(false);
      setIsFieldError(false);
    }, 3000);
  };

  const handleTncCheckbox = index => {
    const value = formValues.tncs[index];
    analytics?.trackTravDetailsEvents({
      actionType: `disclaimer_${value ? "unchecked" : "checked"}`
    });
    setValue(`tncs.${index}`, !value);
    trigger(`tncs.${index}`);
  };

  const filterTravellers = async (selected, errors) => {
    let targetPosition = 0;
    const newIndices = new Array(travellerData.length);
    const errorIndices = errors.map(err => err.index);
    travellerData.forEach((traveller, index) => {
      if (errorIndices.includes(index)) {
        newIndices[index] = targetPosition;
        targetPosition++;
      }
    });
    travellerData.forEach((traveller, index) => {
      if (selected.includes(index) && !errorIndices.includes(index)) {
        newIndices[index] = targetPosition;
        targetPosition++;
      }
    });
    travellerData.forEach((traveller, index) => {
      if (!selected.includes(index) && !errorIndices.includes(index)) {
        newIndices[index] = targetPosition;
        targetPosition++;
      }
    });
    const newArray = [];
    newIndices.forEach((indexVal, index) => {
      newArray[indexVal] = getValues(`travellerData.${index}`);
    }); // Replace the array with the reordered one

    setValue("travellerData", newArray);
    const isValid = await trigger("travellerData");
    errors.forEach(({
      index,
      errorType
    }, ind) => {
      const fieldKey = `travellerData.${ind}.${errorType}`; // errorTrackEvent({
      //   error_details_list: [{
      //     error_message: getFormFieldErrorMsg(errorType as FormFieldType),
      //     error_source: fieldKey,
      //     error_severity: 3,
      //   }],
      // })

      setError(fieldKey, {
        message: (0,utils/* getFormFieldErrorMsg */.YV)(errorType)
      });
    });
  }; // Simplified payment flow without login logic


  const onSubmit = async formData => {
    // Only set local loading state if no external loading management
    if (externalIsLoading === undefined) {
      setLocalIsLoading(true);
    }

    try {
      // Pass form data to parent component for handling
      if (onFormDataChange) {
        onFormDataChange(formData);
      } // Pass selected country to parent


      if (getSelectedCountry && selectedCountry) {
        getSelectedCountry(selectedCountry);
      } // Track analytics events


      analytics?.trackTravDetailsEvents({
        actionType: "traveller_name_filled"
      }, "pageView", type);
      analytics?.trackTravDetailsEvents({
        actionType: "contact_details_filled"
      }, "pageView", type);
      analytics?.trackTravDetailsEvents({
        actionType: "dob_selected"
      }, "pageView", type);
      analytics?.trackTravDetailsEvents({
        actionType: "gender_selected"
      }, "pageView", type); // Since user is always logged in, proceed directly to payment

      if (handleTravellerPayment) {
        await handleTravellerPayment(formData);
      }
    } catch (error) {
      console.error("Payment processing error:", error);
    } finally {
      // Only manage local loading state if no external loading management
      if (externalIsLoading === undefined) {
        setLocalIsLoading(false);
      }
    }
  }; // Handle form validation errors


  const onSubmitError = errors => {
    // Only manage local loading state if no external loading management
    if (externalIsLoading === undefined) {
      setLocalIsLoading(false);
    }

    if (!isFieldError) {
      setIsFieldError(true);
      handleErrorToast();
    } // Handle setting firstErrorIndex like in AddTravellerDetails with improved animation


    if (errors.travellerData?.length) {
      const errorIndex = errors.travellerData?.findIndex?.(error => error);

      if (errorIndex != null && errorIndex >= 0 && setFirstErrorIndex) {
        // Collapse all travellers to show error in collapsed format
        setExpandedTravellerIndex(-1);
        setFirstErrorIndex(errorIndex); // Scroll to error traveller after collapse animation

        scrollToErrorTraveller(errorIndex, 350);
      }
    } else if (errors.primaryContactData?.email || errors.primaryContactData?.mobile) {
      // Add animation delay for primary contact errors
      setTimeout(() => {
        primaryContactRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "center"
        });
      }, 150);
    } else if (errors.tncs?.length) {
      // Add animation delay for TnC errors
      setTimeout(() => {
        tncRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "center"
        });
      }, 150);
    }
  }; // Main validation and buy handler like in AddTravellerDetails


  const handleBuy = (fromBenefitModal = false) => {
    (0,xdmEvents/* trackEvent */.L9)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "buy_clicked"
      }
    });
    analytics?.trackTravDetailsEvents({
      actionType: "buy_clicked"
    }, "pageView", type);

    if (selectedCount !== travellerCount) {
      if (!isFieldError) {
        setIsFieldError(true);

        if (setFirstErrorIndex) {
          setFirstErrorIndex(0);
        } // Collapse all travellers to show error in collapsed format


        setExpandedTravellerIndex(-1); // Scroll to first traveller after collapse animation

        scrollToErrorTraveller(0, 300);
        handleErrorToast();
      }
    } else {
      const formValues = getValues();
      const selected = [];
      const errorArr = [];
      formValues?.travellerData?.map((item, index) => {
        const {
          name: fullName,
          dob: dobValue,
          gender: genderType,
          passport: passportType,
          nomineeName: nomineeNameType,
          isSelected
        } = item || {};

        if (isSelected) {
          selected.push(index);
        }

        const fieldState = getFieldState(`travellerData.${index}`);
        const {
          isTouched
        } = fieldState;

        if (!isTouched) {
          if (secondaryContactFields?.name?.isRequired && !fullName) {
            if (selected.includes(index)) {
              errorArr.push({
                index,
                errorType: "name"
              });
            }
          } else if (secondaryContactFields?.dob?.isRequired && !dobValue) {
            if (selected.includes(index)) {
              errorArr.push({
                index,
                errorType: "dob"
              });
            }
          } else if (secondaryContactFields?.gender?.isRequired && !genderType) {
            if (selected.includes(index)) {
              errorArr.push({
                index,
                errorType: "gender"
              });
            }
          } else if (secondaryContactFields?.passport?.isRequired && !passportType) {
            if (selected.includes(index)) {
              errorArr.push({
                index,
                errorType: "passport"
              });
            }
          } else if (secondaryContactFields?.nomineeName?.isRequired && !nomineeNameType) {
            if (selected.includes(index)) {
              errorArr.push({
                index,
                errorType: "nomineeName"
              });
            }
          }
        }
      });
      filterTravellers(selected, errorArr); // If there are errors, collapse all travellers and focus on first error

      if (errorArr.length > 0 && setFirstErrorIndex) {
        const firstErrorIndex = errorArr[0]?.index ?? 0;
        setExpandedTravellerIndex(-1); // Collapse all to show error in collapsed format

        setFirstErrorIndex(firstErrorIndex); // Scroll to error traveller after collapse animation

        scrollToErrorTraveller(firstErrorIndex, 350);
      }

      handleSubmit(onSubmit, onSubmitError)();
    }
  };

  const templateIdCounter = {
    top: {},
    left: {},
    right: {}
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TravellerDetailLayoutV2, {
    id: "pageId",
    "data-test-id": "InsTravDetailV2-TravellerDetailLayoutV2",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(InsuranceTravelDetailsV2_styles_HeadComp, {
      "data-test-id": "InsTravDetailV2-HeadComp",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(static_components.BreadcrumbComponent, {
        "data-test-id": "InsTravDetailV2-BreadcrumbComponent"
      }), components?.map(card => {
        const CardComponent = mypartner/* MYPARTNER_COMPONENT_MAPPER.top */.L.top[card.id];

        if (CardComponent) {
          templateIdCounter.top[card.id] = templateIdCounter.top[card.id] || 0;
          templateIdCounter.top[card.id]++;
          return /*#__PURE__*/(0,jsx_runtime.jsx)(CardComponent, InsuranceTravellerDetailV2_objectSpread(InsuranceTravellerDetailV2_objectSpread({}, card.data), {}, {
            "data-test-id": "InsTravDetailV2-CardComponent"
          }), `top-${card.id}-${templateIdCounter.top[card.id]}`);
        }

        return null;
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(InsuranceTravelDetailsV2_styles_MainContainer, {
      "data-test-id": "InsTravDetailV2-MainContainer",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceTravelDetailsV2_styles_LeftComp, {
        "data-test-id": "InsTravDetailV2-LeftComp",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(index_esm/* FormProvider */.RV, InsuranceTravellerDetailV2_objectSpread(InsuranceTravellerDetailV2_objectSpread({}, methods), {}, {
          "data-test-id": "InsTravDetailV2-FormProvider",
          children: components?.map(card => {
            const CardComponent = mypartner/* MYPARTNER_COMPONENT_MAPPER.left */.L.left[card.id];

            if (CardComponent) {
              templateIdCounter.left[card.id] = templateIdCounter.left[card.id] || 0;
              templateIdCounter.left[card.id]++;
              return /*#__PURE__*/(0,jsx_runtime.jsx)(CardComponent, InsuranceTravellerDetailV2_objectSpread(InsuranceTravellerDetailV2_objectSpread({}, card.data), {}, {
                handleTncCheckbox: handleTncCheckbox,
                setValue: setValue,
                formValues: formValues,
                isLoading: isLoading,
                travellerRef: travellerRef,
                firstErrorIndex: firstErrorIndex,
                selectedCount: selectedCount,
                travellerCount: travellerCount,
                setSecondaryContactFields: setSecondaryContactFields,
                primaryContactRef: primaryContactRef,
                tncRef: tncRef,
                onPayment: handleBuy,
                expandedTravellerIndex: expandedTravellerIndex,
                setExpandedTravellerIndex: setExpandedTravellerIndex,
                visibleTravellersCount: pageData?.visibleTravellersCount || 5,
                "data-test-id": "InsTravDetailV2-CardComponent"
              }), `left-${card.id}-${templateIdCounter.left[card.id]}`);
            }

            return null;
          })
        }))
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceTravelDetailsV2_styles_RightComp, {
        "data-test-id": "InsTravDetailV2-RightComp",
        children: components?.map(card => {
          const CardComponent = mypartner/* MYPARTNER_COMPONENT_MAPPER.right */.L.right[card.id];

          if (CardComponent) {
            templateIdCounter.right[card.id] = templateIdCounter.right[card.id] || 0;
            templateIdCounter.right[card.id]++;
            return /*#__PURE__*/(0,jsx_runtime.jsx)(CardComponent, InsuranceTravellerDetailV2_objectSpread(InsuranceTravellerDetailV2_objectSpread({}, card.data), {}, {
              onPayment: handleBuy,
              isLoading: isLoading,
              formValues: formValues,
              travellerRef: travellerRef,
              firstErrorIndex: firstErrorIndex,
              selectedCount: selectedCount,
              travellerCount: travellerCount,
              setSecondaryContactFields: setSecondaryContactFields,
              primaryContactRef: primaryContactRef,
              tncRef: tncRef,
              expandedTravellerIndex: expandedTravellerIndex,
              setExpandedTravellerIndex: setExpandedTravellerIndex,
              "data-test-id": "InsTravDetailV2-CardComponent"
            }), `right-${card.id}-${templateIdCounter.right[card.id]}`);
          }

          return null;
        })
      })]
    }), isSelectedError && /*#__PURE__*/(0,jsx_runtime.jsx)(WebToast/* default */.Z, {
      toastTxt: `Already selected ${travellerCount} ${travellerCount === 1 ? "traveller" : "travellers"}, Remove before adding one.`,
      position: "fixed",
      right: "50px",
      margin: device === "lg" ? "0px 0px 0px 28px" : "",
      height: "40px",
      bottom: device === "sm" ? "70px" : "50px",
      "data-test-id": "InsTravDetailV2-WebToast"
    }), isFieldError && /*#__PURE__*/(0,jsx_runtime.jsx)(WebToastWrap, {
      "data-test-id": "InsTravDetailV2-WebToastWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(WebToast/* default */.Z, {
        type: "error",
        position: "fixed",
        right: "50px",
        bottom: device === "sm" ? "70px" : "50px",
        toastTxt: selectedCount === travellerCount ? pageFormErrorToast?.message || formErrorToast : pageAddErrorToast?.message || addErrorToast,
        color: "#6B4300",
        "data-test-id": "InsTravDetailV2-WebToast"
      })
    })]
  });
};

/* harmony default export */ const InsuranceTravellerDetailV2 = (InsTravDetailV2);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/InsuranceTravellerDetail/TravelDetailsV2Context.tsx


function TravelDetailsV2Context_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TravelDetailsV2Context_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TravelDetailsV2Context_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TravelDetailsV2Context_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




const TravelDetailsV2Context = /*#__PURE__*/(0,react.createContext)(undefined);

/**
 * TravelDetailsV2ContextProvider provides traveller data and related functions
 * to child components. This context centralizes the management of traveller
 * details data and provides a clean API for components to interact with it.
 *
 * Usage example:
 * ```tsx
 * const MyComponent = () => {
 *   const {
 *     travellerDataFromStore,
 *     saveFormValuesOnBlur,
 *     updateTravellerData
 *   } = useTravelDetailsV2Context();
 *
 *   const handleSave = () => {
 *     saveFormValuesOnBlur();
 *   };
 *
 *   return <div>...</div>;
 * };
 * ```
 */
const TravelDetailsV2ContextProvider = ({
  children,
  initialFormValues
}) => {
  const {
    0: formValues,
    1: setFormValues
  } = (0,react.useState)(initialFormValues || null); // Get initial data from memory (after client-side hydration)

  const {
    0: travellerDataFromStore,
    1: setTravellerDataFromStore
  } = (0,react.useState)({}); // Error state management

  const {
    0: errorState,
    1: setErrorStateInternal
  } = (0,react.useState)({
    firstErrorIndex: -1,
    hasErrors: false,
    errorMessage: null
  }); // Read session storage only after client-side hydration

  (0,react.useEffect)(() => {
    const dataFromStorage = (0,utils/* getTravDetailsFromMemory */.fP)();
    setTravellerDataFromStore(dataFromStorage);
  }, []);
  const getTravellerDetailsFromMemory = (0,react.useCallback)(() => {
    return (0,utils/* getTravDetailsFromMemory */.fP)();
  }, []);
  const setTravellerDetailsInMemory = (0,react.useCallback)(data => {
    (0,utils/* setTravDetailsInMemory */.Yp)(data);
  }, []);
  const saveFormValuesOnBlur = (0,react.useCallback)(index => {
    if (formValues) {
      const currentDataFromStore = (0,utils/* getTravDetailsFromMemory */.fP)();
      setTravellerDetailsInMemory(TravelDetailsV2Context_objectSpread(TravelDetailsV2Context_objectSpread({}, currentDataFromStore), {}, {
        travellerDetails: formValues.travellerData,
        primaryContactDetails: formValues.primaryContactData
      }));
    }
  }, [formValues, setTravellerDetailsInMemory]);
  const updateTravellerData = (0,react.useCallback)(data => {
    if (formValues) {
      setFormValues(TravelDetailsV2Context_objectSpread(TravelDetailsV2Context_objectSpread({}, formValues), {}, {
        travellerData: data
      }));
    }
  }, [formValues]);
  const updatePrimaryContactData = (0,react.useCallback)(data => {
    if (formValues) {
      const currentDataFromStore = (0,utils/* getTravDetailsFromMemory */.fP)();
      setFormValues(TravelDetailsV2Context_objectSpread(TravelDetailsV2Context_objectSpread({}, formValues), {}, {
        primaryContactData: data
      }));
      setTravellerDetailsInMemory(TravelDetailsV2Context_objectSpread(TravelDetailsV2Context_objectSpread({}, currentDataFromStore), {}, {
        primaryContactDetails: data
      }));
    }
  }, [formValues, setTravellerDetailsInMemory]); // Error handling functions

  const setErrorState = (0,react.useCallback)(newErrorState => {
    setErrorStateInternal(prev => TravelDetailsV2Context_objectSpread(TravelDetailsV2Context_objectSpread({}, prev), newErrorState));
  }, []);
  const clearErrors = (0,react.useCallback)(() => {
    setErrorStateInternal({
      firstErrorIndex: -1,
      hasErrors: false,
      errorMessage: null
    });
  }, []);
  const focusOnError = (0,react.useCallback)(index => {
    setErrorState({
      firstErrorIndex: index,
      hasErrors: true
    }); // Add smooth scroll animation to error element

    setTimeout(() => {
      const errorElement = document.querySelector(`[data-traveller-index="${index}"]`);

      if (errorElement) {
        errorElement.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest"
        });
      }
    }, 100);
  }, [setErrorState]);
  const contextValue = {
    travellerDataFromStore,
    formValues,
    errorState,
    saveFormValuesOnBlur,
    updateTravellerData,
    updatePrimaryContactData,
    getTravellerDetailsFromMemory,
    setTravellerDetailsInMemory,
    setErrorState,
    clearErrors,
    focusOnError
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetailsV2Context.Provider, {
    value: contextValue,
    children: children
  });
};
/**
 * Hook to access the TravelDetailsV2Context
 * @returns TravelDetailsV2ContextType
 * @throws Error if used outside of TravelDetailsV2ContextProvider
 */

const useTravelDetailsV2Context = () => {
  const context = (0,react.useContext)(TravelDetailsV2Context);

  if (context === undefined) {
    throw new Error("useTravelDetailsV2Context must be used within a TravelDetailsV2ContextProvider");
  }

  return context;
};
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/InsuranceTravellerDetail/InsuranceTravellerDetailWrapper.tsx


function InsuranceTravellerDetailWrapper_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function InsuranceTravellerDetailWrapper_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? InsuranceTravellerDetailWrapper_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : InsuranceTravellerDetailWrapper_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








const InsuranceTravellerDetailWrapper = props => {
  const partner = (0,utils/* getPartnerOnClientSide */.et)();

  if (partner === src.PARTNER.MYPARTNER) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)(TravelDetailsV2ContextProvider, {
      "data-test-id": "InsuranceTravellerDetailWrapper-TravelDetailsV2ContextProvider",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceTravellerDetailV2, InsuranceTravellerDetailWrapper_objectSpread(InsuranceTravellerDetailWrapper_objectSpread({}, props), {}, {
        "data-test-id": "InsuranceTravellerDetailWrapper-InsTravDetailV2"
      }))
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)(InsuranceTravellerDetail_InsuranceTravellerDetail, InsuranceTravellerDetailWrapper_objectSpread(InsuranceTravellerDetailWrapper_objectSpread({}, props), {}, {
    "data-test-id": "InsuranceTravellerDetailWrapper-InsuranceTravellerDetail"
  }));
};

/* harmony default export */ const InsuranceTravellerDetail_InsuranceTravellerDetailWrapper = (InsuranceTravellerDetailWrapper);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetail/OrderDetail.style.ts


const OrderDetailStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailstyle__OrderDetailStyle",
  componentId: "sc-17nnyum-0"
})(["padding-top:36px;background:#f6f6f6;padding-bottom:30px;@media ", "{padding-top:60px;}"], static_utils/* deviceType.mobile */.vO.mobile);
const OrderDetailWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailstyle__OrderDetailWrap",
  componentId: "sc-17nnyum-1"
})(["width:1200px;margin:0 auto;display:flex;flex-direction:column;gap:16px;@media ", "{width:100%;}"], static_utils/* deviceType.mobile */.vO.mobile);
const OrderDetailContent = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailstyle__OrderDetailContent",
  componentId: "sc-17nnyum-2"
})(["display:flex;gap:18px;@media ", "{flex-direction:column;gap:8px;}"], static_utils/* deviceType.mobile */.vO.mobile);
const OrderDetailLeft = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailstyle__OrderDetailLeft",
  componentId: "sc-17nnyum-3"
})(["flex:1;display:flex;flex-direction:column;gap:16px;"]);
const OrderDetailRight = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailstyle__OrderDetailRight",
  componentId: "sc-17nnyum-4"
})(["flex-shrink:0;width:288px;display:flex;flex-direction:column;gap:16px;@media ", "{width:100%;}"], static_utils/* deviceType.mobile */.vO.mobile);
const OrderDetailMobileHd = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailstyle__OrderDetailMobileHd",
  componentId: "sc-17nnyum-5"
})(["padding:30px;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;background:#fff;"]);
const PageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailstyle__PageContainer",
  componentId: "sc-17nnyum-6"
})(["background:#f2f2f2;padding:30px;height:calc(100vh- 80px);@media ", "{padding:16px;}"], static_utils/* deviceType.mobile */.vO.mobile);
const PageGreyWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderDetailstyle__PageGreyWrap",
  componentId: "sc-17nnyum-7"
})(["width:1200px;margin:0 auto;background:#f2f2f2;height:calc(100vh - 80px);gap:16px;display:flex;flex-direction:column;@media ", "{width:100%;}"], static_utils/* deviceType.mobile */.vO.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetail/DownloadPolicy.tsx





const DownloadPolicy = ({
  data
}) => {
  const {
    screen,
    travellersInsured
  } = data;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(PageContainer, {
    id: "pageId",
    "data-test-id": "DownloadPolicy-PageContainer",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(PageGreyWrap, {
      "data-test-id": "DownloadPolicy-PageGreyWrap",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(static_components.H4Tag, {
        "data-test-id": "DownloadPolicy-H4Tag",
        children: screen.title
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.DnldPolicyComponent, {
        data: screen.list,
        travellersInsured: travellersInsured,
        "data-test-id": "DownloadPolicy-DnldPolicyComponent"
      })]
    })
  });
};

/* harmony default export */ const OrderDetail_DownloadPolicy = (DownloadPolicy);
// EXTERNAL MODULE: ../../libs/server-api-utils/src/index.ts + 16 modules
var server_api_utils_src = __webpack_require__(97685);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderDetail/OrderDetail.tsx


function OrderDetail_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function OrderDetail_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? OrderDetail_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : OrderDetail_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
















const OrderDetail_analytics = (0,insurance/* getAnalytics */.I)();

const OrderDetail = ({
  data
}) => {
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const {
    0: orderData,
    1: setOrderData
  } = (0,react.useState)(data);
  const {
    0: addAlternateContact,
    1: setHandleAlternateContact
  } = (0,react.useState)(false);
  const {
    0: showBenefitsModal,
    1: setShowBenefitsModal
  } = (0,react.useState)(false);
  const {
    0: emailPolicyText,
    1: setEmailPolicyText
  } = (0,react.useState)("");
  const {
    0: editDetailSheet,
    1: setEditDetailSheet
  } = (0,react.useState)(false);

  const handleClickEditDetailSheet = () => {
    setEditDetailSheet(!editDetailSheet);
  };

  const {
    title,
    bookingId,
    orderDetailsData,
    downloadPolicy,
    addPassportDetailData,
    editTraveller,
    isPassportDetailsAvailable,
    travelAssistance,
    isExpired
  } = orderData || {};
  const {
    insPlanName,
    insuranceInfo,
    planType,
    planIcon,
    planDetails,
    orderDetails,
    totalBenefits,
    travellersInsured,
    primaryContact,
    orderGethelp,
    forInsuranceContainer
  } = orderDetailsData || {};
  const planData = {
    moreBenefits: planDetails?.moreBenefits,
    packName: planDetails?.planType,
    insuranceType: planDetails?.planName,
    insPlanName: planDetails?.planBenefitsSubHeader?.insurerName,
    vendorDisplayPrefix: planDetails?.planBenefitsSubHeader?.insurerInfo,
    ctaLink: planDetails?.TnC?.tncText,
    planExtraInfo: planDetails?.claimSettled,
    service: planDetails?.planBenefitsInfo,
    tncLink: planDetails?.TnC?.tncLink
  };
  const experiment = (0,react.useContext)(ui_widgets_src/* ExperimentTrackingString */.Mq) || "";
  (0,react.useEffect)(() => {
    OrderDetail_analytics?.trackPageLoadEvent({
      pageName: "ORDER_DETAILS",
      experiment
    });
    (0,XDMAnalytics.initializePageTracking)({
      page_context: {
        page_name: "thankyou",
        page_type: "funnel",
        funnel_step: "thankyou",
        subpage_name: "order_details"
      }
    });
  }, []);
  (0,react.useEffect)(() => {
    if (data) {
      setOrderData(data);
    }
  }, [data]);
  /* istanbul ignore next */

  const handleAlternateContact = () => {
    setHandleAlternateContact(!addAlternateContact);
  };

  const insuranceHandler = async item => {
    if (item?.link) {
      setEmailPolicyText("");

      if (item.sectionType === "CLAIM_INSURANCE") {
        OrderDetail_analytics?.trackOrderDetailsEvents({
          actionType: "claim_insurance_clicked"
        } //"click"
        );
        (0,XDMAnalytics.trackEvent)({
          event_detail: {
            event_type: "action",
            event_name: "component_cta-clicked",
            event_value: "claim_insurance_clicked"
          }
        });
      } else if (item.sectionType === "RAISE_ISSUE") {
        OrderDetail_analytics?.trackOrderDetailsEvents({
          actionType: "raise_issue_clicked"
        } //"click"
        );
        (0,XDMAnalytics.trackEvent)({
          event_detail: {
            event_type: "action",
            event_name: "component_cta-clicked",
            event_value: "raise_issue_clicked"
          }
        });
      }

      return window.open(item?.link, "_blank");
    } else {
      if (item?.sectionType === "EMAIL") {
        const partner = (0,utils/* getPartnerOnClientSide */.et)();
        let toastMessage = await (0,api/* sendPolicyEmail */.S8)({
          bookingId,
          partner
        });
        setEmailPolicyText(toastMessage.data.Description);
        OrderDetail_analytics?.trackOrderDetailsEvents({
          actionType: "email_policy_clicked"
        } //"click"
        );
        (0,XDMAnalytics.trackEvent)({
          event_detail: {
            event_type: "action",
            event_name: "component_cta-clicked",
            event_value: "email_policy_clicked"
          }
        });
        return "";
      } else return;
    }
  };

  const navigateToDownloadPolicy = () => {
    const queryParameters = new URLSearchParams(window.location.search);
    const bookingId = queryParameters.get("bookingId");
    const meta_lob = queryParameters.get("meta_lob");

    const data = OrderDetail_objectSpread({
      bookingId
    }, meta_lob === "corp" && {
      meta_lob
    });

    OrderDetail_analytics?.trackOrderDetailsEvents({
      actionType: "download_policy_clicked"
    } //"click"
    );
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "download_policy_clicked"
      }
    });
    (0,XDMAnalytics.triggerPageExit)();
    return navigation/* navigationActions.navigateToDownloadPolicy */.ej.navigateToDownloadPolicy(data);
  };

  const navigateToAddPassport = () => {
    OrderDetail_analytics?.trackOrderDetailsEvents({
      actionType: "add_passport_clicked"
    } //"click"
    );
    navigation/* navigationActions.navigateToAddPassport */.ej.navigateToAddPassport({
      bookingId,
      pageId: src.PASSPORT_DETAILS_PAGE_ID.ORDER_CONFIRMED
    });
  };
  /* istanbul ignore next */


  const handleViewBebefitsClick = () => {
    setShowBenefitsModal(true);
    OrderDetail_analytics?.trackOrderDetailsEvents({
      actionType: "view_benefits_clicked"
    } //"click"
    );
  };

  const updateOrderDetails = async () => {
    try {
      const queryParams = new URLSearchParams(window.location.search);
      const bookingId = queryParams.get("bookingId");
      const partner = (0,utils/* getPartnerOnClientSide */.et)();
      const dvid = (0,utils/* getDeviceIdForClient */.fV)();
      const reqData = {
        partner,
        bookingId: bookingId,
        cookie: document.cookie,
        dvid: dvid || ""
      };
      const response = await (0,server_api_utils_src/* getOrderDetails */.s$)(reqData);
      setOrderData(response?.data?.data);
    } catch (error) {
      console.log("Error", {
        error
      });
    }
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(OrderDetailStyle, {
      id: "pageId",
      "data-test-id": "OrderDetail-OrderDetailStyle",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailWrap, {
        "data-test-id": "OrderDetail-OrderDetailWrap",
        children: [device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsxs)(static_components.H4Tag, {
          "data-test-id": "OrderDetail-H4Tag",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(static_components.FormattedText, {
            value: title,
            "data-test-id": "OrderDetail-FormattedText"
          }), " ", /*#__PURE__*/(0,jsx_runtime.jsxs)(static_components.SpanTag, {
            fontSize: "large",
            "data-test-id": "OrderDetail-SpanTag",
            children: [" (", bookingId, ") "]
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailContent, {
          "data-test-id": "OrderDetail-OrderDetailContent",
          children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailLeft, {
            "data-test-id": "OrderDetail-OrderDetailLeft",
            children: [device == "sm" && /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailMobileHd, {
              "data-test-id": "OrderDetail-OrderDetailMobileHd",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(static_components.ImageComponent, {
                width: "60px",
                height: "40px",
                src: "https://tripmoneycmsimgak.mmtcdn.com/img/trip_Secured_9a14d8e25c.svg",
                "data-test-id": "OrderDetail-ImageComponent"
              }), /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.ParaTag, {
                fontSize: "md",
                fontWeight: "bold",
                "data-test-id": "OrderDetail-ParaTag",
                children: "Your Trip Is Secured"
              }), /*#__PURE__*/(0,jsx_runtime.jsxs)(static_components.ParaTag, {
                fontSize: "xs",
                color: Global/* theme.greyText7 */.rS.greyText7,
                "data-test-id": "OrderDetail-ParaTag",
                children: ["Order Id (", bookingId, ")"]
              }), downloadPolicy?.buttonTitle && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.LandingButton, {
                customWidth: "100%",
                customTitle: downloadPolicy.buttonTitle,
                onClick: navigateToDownloadPolicy,
                "data-test-id": "OrderDetail-LandingButton"
              }), !isPassportDetailsAvailable && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.AddPassportDetail, {
                data: addPassportDetailData,
                handlePassportBtn: navigateToAddPassport,
                "data-test-id": "OrderDetail-AddPassportDetail"
              })]
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.OrderDetailInsurance, {
              insPlanName: insPlanName,
              insuranceInfo: insuranceInfo,
              insuranceType: planType,
              orderDetailIcon: planIcon,
              orderDetails: orderDetails,
              forInsuranceContainer: forInsuranceContainer,
              handleClickInsurance: insuranceHandler // insuranceTypeColor={
              //     orderDetailsData.insuranceTypeColor
              // }
              ,
              "data-test-id": "OrderDetail-OrderDetailInsurance"
            }), planDetails.title && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.OrderDetailPlan, {
              title: planDetails?.title,
              orderDetailIcon: planDetails?.icon,
              planBenefits: planDetails?.planBenefits // totalBenefits={totalBenefits}
              ,
              handleMoreBenefits: handleViewBebefitsClick,
              subTitle: planDetails?.subtitle,
              benefitsCTA: planDetails?.benefitsCTA,
              "data-test-id": "OrderDetail-OrderDetailPlan"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.OrderDetailTraveller, {
              title: travellersInsured?.title,
              orderDetailIcon: travellersInsured?.icon,
              travellerDetails: travellersInsured?.travellerDetails,
              editEnabled: !isExpired,
              editTraveller: editTraveller,
              updateOrderDetails: updateOrderDetails,
              handleClickEditDetailSheet: handleClickEditDetailSheet,
              "data-test-id": "OrderDetail-OrderDetailTraveller"
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.PrimaryContact, {
              title: primaryContact?.title,
              orderDetailIcon: primaryContact?.icon,
              contactDetails: primaryContact?.contactDetails,
              handleAlternateContact: handleAlternateContact,
              "data-test-id": "OrderDetail-PrimaryContact"
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderDetailRight, {
            "data-test-id": "OrderDetail-OrderDetailRight",
            children: [travelAssistance && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.TravAssistant, {
              cardTitle: travelAssistance?.heading?.title,
              cardInfo: travelAssistance?.heading?.info,
              helpLineNo: travelAssistance?.body?.title,
              cardIcon: travelAssistance?.body?.icons,
              "data-test-id": "OrderDetail-TravAssistant"
            }), !isPassportDetailsAvailable && device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.AddPassportDetail, {
              data: addPassportDetailData,
              handlePassportBtn: navigateToAddPassport,
              "data-test-id": "OrderDetail-AddPassportDetail"
            }), downloadPolicy?.buttonTitle && device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.LandingButtonWhite, {
              btnLeftIcon: downloadPolicy.leftIconUrl,
              btnRightIcon: downloadPolicy.rightIconUrl,
              customTitle: downloadPolicy.buttonTitle,
              customWidth: "100%",
              onClick: navigateToDownloadPolicy,
              "data-test-id": "OrderDetail-LandingButtonWhite"
            }), forInsuranceContainer?.forInsurance?.length && device == "lg" ? /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.OrderInsurance, {
              title: forInsuranceContainer?.title,
              forInsurance: forInsuranceContainer?.forInsurance,
              handleClickInsurance: insuranceHandler,
              "data-test-id": "OrderDetail-OrderInsurance"
            }) : /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}), orderGethelp && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.OrderGetHelp, {
              title: orderGethelp.title,
              getHelp: orderGethelp.getHelp,
              "data-test-id": "OrderDetail-OrderGetHelp"
            })]
          })]
        })]
      })
    }), addAlternateContact && device === "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.AddAlternateContact, {
      handleAlternateContact: handleAlternateContact,
      title: "Add Alternative Contact",
      goBackTxt: "Go Back",
      addContactTxt: "Add Contact",
      handleAddContact: () => {},
      handleGoBack: () => {},
      "data-test-id": "OrderDetail-AddAlternateContact"
    }), showBenefitsModal && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.MoreBenefits, {
      handleClose: () => setShowBenefitsModal(false),
      moreBenfitsTitle: totalBenefits,
      data: planData,
      "data-test-id": "OrderDetail-MoreBenefits"
    }), emailPolicyText && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.Toast, {
      toastCloseIcon: "https://tripmoneycmsimgak.mmtcdn.com/img/cross_grey_rounded_e24cbc15d7.svg",
      toastIcon: "https://tripmoneycmsimgak.mmtcdn.com/img/green_Check_Img_1c5717e1ba.svg",
      planSelectedTxt: emailPolicyText,
      autoCloseDuration: 5000,
      width: "24px",
      height: "24px",
      showToast: emailPolicyText != "",
      handleClose: () => setEmailPolicyText(""),
      "data-test-id": "OrderDetail-Toast"
    }), editDetailSheet && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.EditTravellerSheet, {
      travellerData: travellersInsured?.travellerDetails,
      handleClose: handleClickEditDetailSheet,
      editTraveller: editTraveller,
      updateOrderDetails: updateOrderDetails,
      "data-test-id": "OrderDetail-EditTravellerSheet"
    })]
  });
};

/* harmony default export */ const OrderDetail_OrderDetail = (OrderDetail);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderListingPage/OrderListingPage.style.ts


const OrderListingPage_style_PageContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderListingPagestyle__PageContainer",
  componentId: "yg6sua-0"
})(["background:#f2f2f2;padding:30px;@media ", "{padding:60px 0 30px;}"], static_utils/* deviceType.mobile */.vO.mobile);
const OrderListingPage_style_PageGreyWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "OrderListingPagestyle__PageGreyWrap",
  componentId: "yg6sua-1"
})(["width:1200px;margin:0 auto;background:#f2f2f2;gap:16px;display:flex;flex-direction:column;@media ", "{width:100%;}"], static_utils/* deviceType.mobile */.vO.mobile);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/OrderListingPage/OrderListingPage.tsx








const OrderListingPage_analytics = (0,insurance/* getAnalytics */.I)();

const OrderListingPage = ({
  orderListingData
}) => {
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const experiment = (0,react.useContext)(ui_widgets_src/* ExperimentTrackingString */.Mq) || "";
  (0,react.useEffect)(() => {
    OrderListingPage_analytics?.trackPageLoadEvent({
      pageName: "ORDER_SUMMARY",
      experiment
    });
    (0,XDMAnalytics.initializePageTracking)({
      page_context: {
        page_name: "thankyou",
        funnel_step: "thankyou",
        page_type: "funnel",
        subpage_name: "order_listing"
      }
    });
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsx)(OrderListingPage_style_PageContainer, {
    id: "pageId",
    "data-test-id": "OrderListingPage-PageContainer",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)(OrderListingPage_style_PageGreyWrap, {
      "data-test-id": "OrderListingPage-PageGreyWrap",
      children: [device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.H5Tag, {
        "data-test-id": "OrderListingPage-H5Tag",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.FormattedText, {
          value: `My Orders (${orderListingData?.length})`,
          "data-test-id": "OrderListingPage-FormattedText"
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.OrderListingComp, {
        data: orderListingData,
        "data-test-id": "OrderListingPage-OrderListingComp"
      })]
    })
  });
};

/* harmony default export */ const OrderListingPage_OrderListingPage = (OrderListingPage);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/persuasionBannerBg.svg
/* harmony default export */ const persuasionBannerBg = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/insurance-seo-pages/_next/static/media/persuasionBannerBg.7381acf2.svg","height":337,"width":880});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/birlaLogo.png
/* harmony default export */ const birlaLogo = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/insurance-seo-pages/_next/static/media/birlaLogo.af76f862.png","height":49,"width":48,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA5ElEQVR42g3NS0rDUBhA4fPfB7kV29RQUGet4qBFhIqOixPX4BLclHMX4gtHdSgKQksRUVDoK0mT/IbDGX9y1z29VjFX/qBRiCr6U78jFB9rJ1Zv5b471NwHFrsF/TOL60W83Kxorw12k+N0Ay7RsnX0JflsxjK0iIcJ5qGjgHVagQveNo8v+H1aoNNA50T4e3yjpnF8Lij322TzAWGQYRqB9HuJvj8jSYRj1FUiL/nklWq+AgEbN5FRD1B15vJcbBzjkwSlLk3JJlPkcA9ADKpjqgrbCGq8x2432er31UQRlOX4H6GkWCfZtJYxAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/icons/flightUpcoming.svg
/* harmony default export */ const flightUpcoming = ({"src":"//jsak.mmtcdn.com/tripmoney/apps/insurance-seo-pages/_next/static/media/flightUpcoming.a0886eb0.svg","height":115,"width":225});
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/ThankYouPage/mockData.tsx



const thankYouPageData = {
  title: "Your trip is successfully secured with Tripmoney",
  info: "Confirmation and order details are sent to <b>chhavi.singh@gmail.com</b> and <b>+91-78381-8903</b>",
  status: "pending",
  statusBg: flightUpcoming.src,
  tagMessage: "PASSPORT DETAILS PENDING"
};
const orderDetails = {
  planName: "TripMoney Tourer Plus Advanced Insurance",
  packName: "TATA AIG General Insurance",
  insPackName: "INSURANCE + ASSISTANCE (COMBO)",
  packColor: Global/* theme.purpleTxt */.rS.purpleTxt,
  packImg: birlaLogo.src,
  orderDetailAmt: [{
    orderDetail: "Total Amount",
    info: "₹ 25,155"
  }, {
    orderDetail: "Order ID",
    info: "TM93567683990"
  }, {
    orderDetail: "Sum Inusred",
    info: "Upto ₹ 1,00,000"
  }, {
    orderDetail: "Travellers Inusred",
    info: "5  TRAvellers"
  }, {
    orderDetail: "Destination Covered",
    info: "Thailand, Singapore"
  }]
};
const manageInsData = {
  title: "Manage Your Insurance<br/> & Get All The Help",
  info: "<b>Modify</b> your Insurance, <b>View Insurance Benefits</b>  and <b>Claim Insurance</b> and lot more, right from the app.",
  orderBtn: "GO TO YOUR ORDERS"
};
const persuasionData = [{
  id: "1",
  boldText: "RBI",
  normalText: "Authorized"
}, {
  id: "2",
  boldText: "Best Exchange Rates",
  normalText: "in the market"
}, {
  id: "3",
  boldText: "Transparent",
  normalText: "conversion rates"
}];
const addPassportDetailData = {
  addPasstitle: "Please add your passport details <b>before Fri, 12 November 2022</b>  to generate policy document",
  addPassInfo: "Since your are travelling to an insurance mandatory country, Download the provisional policy from here.",
  addPassportCta: "DOWNLOAD PROVISIONAL POLICY",
  addPassportBtn: "ADD PASSPORT DETAILS"
};
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/PersuasionBanner/PersuasionBanner.style.tsx
var PersuasionBanner_style = __webpack_require__(82207);
// EXTERNAL MODULE: ../../libs/ui/src/lib/static/components/TextStyles/TextStyles.style.ts
var TextStyles_style = __webpack_require__(93139);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/ThankYouPage/ThankYouPage.style.ts




const ThankYouPageStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ThankYouPagestyle__ThankYouPageStyle",
  componentId: "a49mxz-0"
})(["background:#f6f6f6;position:relative;z-index:1;padding-bottom:20px;@media ", "{padding:16px;}"], static_utils/* deviceType.mobile */.vO.mobile);
const ThankYouPageWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ThankYouPagestyle__ThankYouPageWrap",
  componentId: "a49mxz-1"
})(["display:flex;gap:20px;width:1200px;margin:0 auto;", "{margin:0;@media ", "{margin-bottom:16px;min-height:unset;}}@media ", "{flex-direction:column;width:100%;}"], PersuasionBanner_style/* PersuasionBannerStyle */.G, static_utils/* deviceType.mobile */.vO.mobile, static_utils/* deviceType.mobile */.vO.mobile);
const ThankYouPageHeadWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ThankYouPagestyle__ThankYouPageHeadWrap",
  componentId: "a49mxz-2"
})(["padding-top:25px;display:flex;background:#fff;@media ", "{padding:80px 16px 20px;}"], static_utils/* deviceType.mobile */.vO.mobile);
const ThankYouPageHead = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ThankYouPagestyle__ThankYouPageHead",
  componentId: "a49mxz-3"
})(["background:#fff;width:1200px;margin:0 auto;padding-bottom:48px;position:relative;@media ", "{padding-bottom:0;width:100%;}", "{@media ", "{width:64%;}}"], static_utils/* deviceType.mobile */.vO.mobile, TextStyles_style/* ParaTagStyle */.OG, static_utils/* deviceType.mobile */.vO.mobile);
const ThankYouPageLeft = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "ThankYouPagestyle__ThankYouPageLeft",
  componentId: "a49mxz-4"
})(["flex:1;margin-top:-22px;"]);
const ThankYouPageRight = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
  displayName: "ThankYouPagestyle__ThankYouPageRight",
  componentId: "a49mxz-5"
})(["width:300px;flex-shrink:0;display:flex;flex-direction:column;gap:16px;margin-top:-22px;@media ", "{width:100%;}"], static_utils/* deviceType.mobile */.vO.mobile);
const ThankYouMwebStyle = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ThankYouPagestyle__ThankYouMwebStyle",
  componentId: "a49mxz-6"
})(["background:#f2f2f2;padding:1px 16px 16px;box-shadow:0px 1px 7px rgba(0,0,0,0.2);border-radius:4px;position:relative;"]);
const FlightUpcomingWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ThankYouPagestyle__FlightUpcomingWrap",
  componentId: "a49mxz-7"
})(["align-self:flex-end;position:absolute;right:0;bottom:0px;display:flex;@media ", "{width:150px;height:80px;bottom:-20px;}"], static_utils/* deviceType.mobile */.vO.mobile);
const PendingStatusTag = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "ThankYouPagestyle__PendingStatusTag",
  componentId: "a49mxz-8"
})(["background:linear-gradient(88.04deg,#c06d0c 0%,#f2c21a 100%);border-radius:16px;margin-bottom:8px;color:#fff;text-transform:uppercase;font-size:12px;line-height:16px;padding:2px 8px;margin-bottom:8px;width:fit-content;font-weight:700;"]);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/ThankYouPage/ThankYouPage.tsx


function ThankYouPage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ThankYouPage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ThankYouPage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ThankYouPage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






 // import "pwa-mmt-ui-header/ssr/header.css";











const persuasionBannerMob = {
  data: persuasionData,
  bgImgURI: persuasionBannerBg.src,
  btnTitle: "Apply Now",
  title: "Congratulations",
  info: `Your are now eligible for <em>Lifetime Free </em>
      <b>Multi Currency Forex Card </b>`
};
const ThankYouPage_analytics = (0,insurance/* getAnalytics */.I)();

const ThankYouPage = ({
  data
}) => {
  const device = (0,ui_widgets_src/* useBreakpointV2 */.bU)();
  const {
    type
  } = (0,ui_src/* usePlanType */.U)();
  const isRenderThankYouPage = (0,react.useRef)(false);
  const {
    title,
    info,
    infoIcon,
    persuasionBanner,
    addPassportDetailData,
    manageInsData,
    orderDetails,
    headerIcon,
    downloadPolicy,
    searchDetails
  } = data;
  const experiment = (0,react.useContext)(ui_widgets_src/* ExperimentTrackingString */.Mq) || "";
  (0,react.useEffect)(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const bookingId = queryParams.get("bookingId");
    ThankYouPage_analytics?.trackPageLoadEvent({
      bookingId: bookingId || "",
      pageName: "THANK_YOU_POLICY",
      experiment
    }, type);

    if (!isRenderThankYouPage.current) {
      (0,XDMAnalytics.initializePageTracking)({
        page_context: {
          page_name: "thankyou",
          funnel_step: "thankyou",
          page_type: "funnel",
          page_url: window.location.href
        },
        event_detail: ThankYouPage_objectSpread(ThankYouPage_objectSpread({
          booking_info: {
            booking_id: bookingId || "",
            status: "success",
            price: searchDetails?.price || (0,utility_src/* parsePriceToNumber */.Pj)(data?.orderDetails?.orderDetailAmt[0]?.info)
          }
        }, searchDetails?.paymentType && {
          payment_details: {
            payment_mode: searchDetails?.paymentType || ""
          }
        }), {}, {
          components: ThankYouPage_objectSpread({}, searchDetails?.productId && {
            product_list: [{
              id: searchDetails?.productId || ""
            }]
          })
        })
      }, {
        countries: searchDetails?.routes?.map(route => ({
          code: route.countryCode || "",
          name: route.countryName || "",
          locusId: route.locusId,
          locusType: route.locusType
        })),
        fromDateTime: searchDetails?.date?.from,
        toDateTime: searchDetails?.date?.to,
        journeyType: searchDetails?.segmentType,
        travellers: searchDetails?.travellers
      });
      isRenderThankYouPage.current = true;
    }
  }, []);

  const navigateToDownloadPolicy = () => {
    const queryParameters = new URLSearchParams(window.location.search);
    const bookingId = queryParameters.get("bookingId");
    const data = {
      bookingId
    };
    ThankYouPage_analytics?.trackThankYouEvents({
      pageName: "THANK_YOU_POLICY",
      actionType: "download_policy_clicked"
    }, "pageView", type);
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: "download_policy_clicked"
      }
    });
    return navigation/* navigationActions.navigateToDownloadPolicy */.ej.navigateToDownloadPolicy(data);
  };

  const goToPassportScreen = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const bookingId = queryParams.get("bookingId");
    ThankYouPage_analytics?.trackThankYouEvents({
      pageName: "THANK_YOU_POLICY",
      actionType: "add_passport_clicked"
    }, "pageView", type);
    return navigation/* navigationActions.navigateToAddPassport */.ej.navigateToAddPassport({
      bookingId,
      pageId: src.PASSPORT_DETAILS_PAGE_ID.PAYMENT_SUCCESS
    });
  };

  const onFeedbackCloseAnalytics = () => {
    ThankYouPage_analytics?.trackThankYouEvents({
      pageName: "THANK_YOU_POLICY",
      actionType: "nps_form_closed"
    }, "pageView", type);
  };

  const onSubmitFeedbackAnalytics = feedbackData => {
    ThankYouPage_analytics?.trackThankYouEvents({
      pageName: "THANK_YOU_POLICY",
      actionType: "nps_submitted"
    }, "pageView", type);
    (0,XDMAnalytics.trackEvent)({
      event_detail: {
        event_type: "action",
        event_name: "component_cta-clicked",
        event_value: feedbackData?.rating ? `nps_submitted_rating_${feedbackData?.rating}` : "nps_submitted"
      }
    });
    ThankYouPage_analytics?.trackThankYouEvents({
      pageName: "THANK_YOU_POLICY",
      actionType: `nps_rating_${feedbackData?.rating}`
    }, "pageView", type);
  };

  const getBookingId = () => {
    const queryParams = new URLSearchParams(window.location.search);
    return queryParams.get("bookingId");
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ThankYouPageHeadWrap, {
      id: "pageId",
      "data-test-id": "ThankYouPage-ThankYouPageHeadWrap",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ThankYouPageHead, {
        "data-test-id": "ThankYouPage-ThankYouPageHead",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(static_components.FlexComp, {
          margin: device == "lg" ? "0 0 8px" : "0 0 30px",
          alignItems: "center",
          "data-test-id": "ThankYouPage-FlexComp",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(static_components.H5Tag, {
            color: Global/* theme.yellowText */.rS.yellowText,
            "data-test-id": "ThankYouPage-H5Tag",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.FormattedText, {
              value: title,
              "data-test-id": "ThankYouPage-FormattedText"
            })
          }), infoIcon && device == "lg" && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.ImageComponent, {
            src: infoIcon,
            height: "15px",
            width: "15px",
            margin: "0 7px 0",
            "data-test-id": "ThankYouPage-ImageComponent"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.ParaTag, {
          fontSize: device == "lg" ? "md" : "xs",
          color: device == "lg" ? Global/* theme.blackText */.rS.blackText : Global/* theme.greyText */.rS.greyText,
          "data-test-id": "ThankYouPage-ParaTag",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.FormattedText, {
            value: info,
            "data-test-id": "ThankYouPage-FormattedText"
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(FlightUpcomingWrap, {
          "data-test-id": "ThankYouPage-FlightUpcomingWrap",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.ImageComponent, {
            src: headerIcon,
            height: device == "lg" ? "115px" : "85px",
            width: device == "lg" ? "225px" : "150px",
            "data-test-id": "ThankYouPage-ImageComponent"
          })
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(ThankYouPageStyle, {
      "data-test-id": "ThankYouPage-ThankYouPageStyle",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(ThankYouPageWrap, {
        "data-test-id": "ThankYouPage-ThankYouPageWrap",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(ThankYouPageLeft, {
          "data-test-id": "ThankYouPage-ThankYouPageLeft",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(static_components.OrderDetails, {
            orderDetails: orderDetails,
            margin: "0 0 16px",
            navigateToDownloadPolicy: navigateToDownloadPolicy,
            downloadPolicy: downloadPolicy,
            "data-test-id": "ThankYouPage-OrderDetails"
          }), persuasionBanner && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.PersuasionBanner, {
            heading: persuasionBanner.title,
            bgImage: persuasionBanner.bgImgURI,
            btnText: persuasionBanner.btnTitle,
            bulletPoints: device == "lg" ? persuasionBanner.data : persuasionBannerMob.data,
            btnHandler: () => window.location.href.includes?.(".goibibo.com") ? window.open("https://tripmoney.goibibo.com/partners/gi/forex/listing?utm_source=insurance_gi&utm_medium=desktop", "_blank") : window.open("https://www.makemytrip.com/forex/?utm_source=tripmoney&utm_medium=insurance-responsive", "_blank"),
            info: persuasionBannerMob.info // crossSell={crossSell}
            ,
            "data-test-id": "ThankYouPage-PersuasionBanner"
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)(ThankYouPageRight, {
          "data-test-id": "ThankYouPage-ThankYouPageRight",
          children: [device == "lg" && downloadPolicy.isEnabled ? /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.LandingButtonWhite, {
            btnLeftIcon: downloadPolicy?.leftIconUrl,
            btnRightIcon: downloadPolicy?.rightIconUrl,
            customTitle: downloadPolicy?.buttonTitle,
            customWidth: "100%",
            onClick: navigateToDownloadPolicy,
            "data-test-id": "ThankYouPage-LandingButtonWhite"
          }) : null, device == "lg" && addPassportDetailData && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.AddPassportDetail, {
            data: addPassportDetailData,
            handlePassportBtn: goToPassportScreen,
            "data-test-id": "ThankYouPage-AddPassportDetail"
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.ManageInsurance, {
            title: manageInsData.title,
            info: manageInsData.info,
            orderBtn: manageInsData.orderBtn,
            handleManageOrder: () => {
              ThankYouPage_analytics?.trackThankYouEvents({
                pageName: "THANK_YOU_POLICY",
                actionType: "my_orders_clicked"
              }, "pageView", type);
              (0,XDMAnalytics.trackEvent)({
                event_detail: {
                  event_type: "action",
                  event_name: "component_cta-clicked",
                  event_value: "my_orders_clicked"
                }
              });

              if (manageInsData?.orderBtnLink) {
                window.location.href = manageInsData?.orderBtnLink;
              } else {
                navigation/* navigationActions.navigateToOrderListing */.ej.navigateToOrderListing();
              }
            },
            orderBtnIcon: manageInsData?.orderBtnIcon,
            goHomeText: manageInsData?.goHomeBtn,
            goHomeBtnIcon: manageInsData?.goHomeBtnIcon,
            "data-test-id": "ThankYouPage-ManageInsurance"
          })]
        }), (0,utils/* isPartnerMMT */.rS)() && /*#__PURE__*/(0,jsx_runtime.jsx)(static_components.TmNPSFeedback, {
          bookingId: getBookingId(),
          onFeedbackCloseAnalytics: onFeedbackCloseAnalytics,
          onSubmitFeedbackAnalytics: onSubmitFeedbackAnalytics,
          "data-test-id": "ThankYouPage-TmNPSFeedback"
        })]
      })
    })]
  });
};

/* harmony default export */ const ThankYouPage_ThankYouPage = (ThankYouPage);
;// CONCATENATED MODULE: ../../libs/ui/src/lib/static/pages/index.ts
















/***/ })

}]);